import { Tab, Tabs } from "react-bootstrap";
import svg from "../components/svg";
import { useEffect, useRef, useState } from "react";
import {
  AlertTypeDesignSetting,
  Gradientcolors,
  HighlightColors,
  widgetAnimations,
} from "../utility/constant";
import { useSelector } from "react-redux";
import PageService from "../service/PageService";
import ColorPicker, { useColorPicker } from "react-best-gradient-color-picker";
import AlertModel from "./common/AlertModel";
import { toast } from "react-toastify";
import debounce from 'lodash/debounce';
import CampaignService from "../service/CampaignService";
import Model from "./common/Model";
import TestAutoCompleteDropDown from "./common/testAutoComplete";
import MultiSelectAutoComplete from "./common/multiSelectAutoComplete";
import Multiselect from "./common/multiselect";
import { ChromePicker  } from "react-color";

export default function AlertType(props) {
  const [activeTab, setActiveTab] = useState("productTab");
  const [alerttemplates, setAlerttemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState()
  const [products, setProducts] = useState([]);
  const [productsOptions, setProductsOptions] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedAlertDesign, setSelectedAlertDesign] = useState({});
  const [highlightColor, setHighlightColor] = useState("");
  const [alertTitleColor, setAlertTitleColor] = useState("");
  const [alertMessageColor, setAlertMessageColor] = useState("");
  const [color, setColor] = useState();
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
  const [degree, setDegree] = useState(120);
  const { setGradient } = useColorPicker(color, setColor);
  const [selectedLeadProject, setSelectedLeadProject] = useState();
  const [selectedVisitorProject, setSelectedVisitorProject] = useState();
  const [selectedSalesProject, setSelectedSalesProject] = useState();
  const [leadPages, setLeadPages] = useState([]);
  const [salesPages, setSalesPages] = useState([]);
  const [visitorPages, setVisitorPages] = useState([]);
  const [alert, setAlert] = useState({
    status: false,
    type: "",
    title: "",
    message: ""
  })
  const [templateType, setTemplateType] = useState("icon");
  const [isTabEnable, setIsTabEnable] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [showAlertColorOption, setShowAlertColorOption] = useState(false);
  const [showMessageColorOption, setShowMessageColorOption] = useState(false);
  const [uploadImageModel, setUploadImageModel] = useState(false);
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [imageLibraryList, setImageLibraryList] = useState([])
  const [imageLoading, setimageLoading] = useState(false);
  const [selectedLeadProjects, setSelectedLeadProjects] = useState([])
  const [selectedLeadPages, setSelectedLeadPages] = useState([])
  const [selectedVisitorProjects, setSelectedVisitorProjects] = useState([])
  const [selectedVisitorPages, setSelectedVisitorPages] = useState([])
  const [IsAlertTitlePicker, setIsAlertTitlePicker] = useState(false)
  const [highlightColorPicker, setHighlightColorPicker] = useState(false)

  const componentRef = useRef(null);
  const inputTitleRef = useRef(null);
  const inputMessageRef = useRef(null);

  const userDetails = useSelector((data) => data.common);

  useEffect(() => {
    if (!userDetails) return
    setimageLoading(true)
    getImagelibrary({ user_id: userDetails.user.id, token: userDetails.token, page: page })
  }, [page])

  useEffect(() => {
    if (!props?.changeTab) return
    setActiveTab("productTab")
    props.updateTab(props.alertType)
    if (props.alertType.name === "Sales Alert") {
      if (props?.alertType?.alertSettings) {
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setSalesPages(props?.alertType?.alertSettings?.funnel_page_id)
        setSelectedSalesProject(props?.alertType?.alertSettings?.funnel_id)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)
        if (!props?.alertType?.alertSettings?.products) return
        if (products?.length > 0) {
          products?.map(product => {
            props?.alertType?.alertSettings?.products?.map(proProduct => {
              if (product.product_id === proProduct.product_id) {
                product.checked = true
              }
            })
          })
          setProducts([...products])
        } else {

          let salesProduct = structuredClone(props?.products)
          let alertProduct = structuredClone(props?.alertType?.alertSettings?.products)
          let updatedProduct = salesProduct?.map(product => {
            const matchedProduct = alertProduct?.find(proProduct => proProduct.product_id === product.product_id);
            if (matchedProduct) {
              product.checked = true;
            }
            return product;
          });
          if (updatedProduct) {
            setProducts([...updatedProduct])
          }
        }


      }

    } else if (props?.alertType?.name === "Leads Alert") {
      setSelectedLeadProject()
      if (props?.alertType?.alertSettings) {
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)

        if (typeof props?.alertType?.alertSettings.funnel_id == "string") {
          let selectedProject1 = getProjectAndPages(JSON.parse(props?.alertType?.alertSettings?.funnel_id), JSON.parse(props?.alertType?.alertSettings?.funnel_page_id), props?.projects)
          if (selectedProject1) {
            // setSelectedLeadProject(selectedProject1?.funnel_id)
          }
        } else {
          let selectedProject1 = getProjectAndPages(props?.alertType?.alertSettings?.funnel_id, props?.alertType?.alertSettings?.funnel_page_id, props?.projects)
          if (selectedProject1) {
            // setSelectedLeadProject(selectedProject1?.funnel_id)
          }
        }
      }
    } else if (props?.alertType?.name === "Visitor Alert") {
      if (props?.alertType?.alertSettings) {
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setTemplateType(props?.alertType?.alertSettings?.alertDesign?.templatetype)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)
        if (typeof props?.alertType?.alertSettings.funnel_id == "string") {
          let selectedProject1 = getProjectAndPages(JSON.parse(props?.alertType?.alertSettings?.funnel_id), JSON.parse(props?.alertType?.alertSettings?.funnel_page_id), props?.projects)
          if (selectedProject1) {
            // setSelectedVisitorProject(selectedProject1?.funnel_id)
          }
        } else {
          let selectedProject1 = getProjectAndPages(props?.alertType?.alertSettings?.funnel_id, props?.alertType?.alertSettings?.funnel_page_id, props?.projects)

          if (selectedProject1) {
            // setSelectedVisitorProject(selectedProject1?.funnel_id)
          }
        }
      }
    }

    if (props?.alertType?.alertSettings?.alertDesign) {
      props.templates.map(item => {
        if (item.id === props?.alertType?.alertSettings?.alertDesign.id) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    }

  }, [props?.changeTab])



  useEffect(() => {
    if (!props.alertType) return;
    if (props.alertType.name === "Sales Alert") {
      if (props?.alertType?.alertSettings) {
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setSalesPages(props?.alertType?.alertSettings?.funnel_page_id)
        setSelectedSalesProject(props?.alertType?.alertSettings?.funnel_id)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)
        if (!props?.alertType?.alertSettings?.products) return
        if (products?.length > 0) {
          products?.map(product => {
            props?.alertType?.alertSettings?.products?.map(proProduct => {
              if (product.product_id === proProduct.product_id) {
                product.checked = true
              }
            })
          })
          setProducts([...products])
        } else {

          let salesProduct = structuredClone(props?.products)
          let alertProduct = structuredClone(props?.alertType?.alertSettings?.products)
          let updatedProduct = salesProduct?.map(product => {
            const matchedProduct = alertProduct?.find(proProduct => proProduct.product_id === product.product_id);
            if (matchedProduct) {
              product.checked = true;
            }
            return product;
          });
          if (updatedProduct) {
            setProducts([...updatedProduct])
          }
        }


      }

    } else if (props?.alertType?.name === "Leads Alert") {
      // console.log("lead1",props?.alertType?.alertSettings)
      if (props?.alertType?.alertSettings) {
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)

        if (typeof props?.alertType?.alertSettings.funnel_id == "string") {
          let selectedProject1 = getProjectAndPages(JSON.parse(props?.alertType?.alertSettings?.funnel_id), JSON.parse(props?.alertType?.alertSettings?.funnel_page_id), props?.projects)
          if (selectedProject1) {
            // setSelectedLeadProject(selectedProject1?.funnel_id)
          }
        } else {
          let selectedProject1 = getProjectAndPages(props?.alertType?.alertSettings?.funnel_id, props?.alertType?.alertSettings?.funnel_page_id, props?.projects)
          if (selectedProject1) {
            // setSelectedLeadProject(selectedProject1?.funnel_id)
          }
        }
      }
    } else if (props.alertType.name === "Visitor Alert") {
      // console.log("Visitor1",props?.alertType?.alertSettings)
      if (props?.alertType?.alertSettings) {
        setSelectedAlertDesign(props?.alertType?.alertSettings?.alertDesign)
        setHighlightColor(props?.alertType?.alertSettings?.alertDesign?.color)
        setColor(props?.alertType?.alertSettings?.alertDesign?.gradientColor)
        setSelectedTemplate(props?.alertType?.alertSettings?.alertDesign)
        setTemplateType(props?.alertType?.alertSettings?.alertDesign?.templatetype)
        setAlertMessageColor(props?.alertType?.alertSettings?.alertDesign?.alertMessage?.color)
        setAlertTitleColor(props?.alertType?.alertSettings?.alertDesign?.alertTitle?.color)
        if (typeof props?.alertType?.alertSettings.funnel_id == "string") {

          let selectedProject1 = getProjectAndPages(JSON.parse(props?.alertType?.alertSettings?.funnel_id), JSON.parse(props?.alertType?.alertSettings?.funnel_page_id), props?.projects)
          if (selectedProject1) {
            // setSelectedVisitorProject(selectedProject1?.funnel_id)
          }
        } else {
          let selectedProject1 = getProjectAndPages(props?.alertType?.alertSettings?.funnel_id, props?.alertType?.alertSettings?.funnel_page_id, props?.projects)
          if (selectedProject1) {
            // setSelectedVisitorProject(selectedProject1?.funnel_id)
          }
        }

      }
    }

  }, [props?.alertType]);


  useEffect(() => {
    if (!props.products || props?.alertType?.alertSettings?.products?.length > 0) return;
    let updatedProduct = props?.products?.map((data) => {
      data["checked"] = false;
      return data;
    });
    let prOptions = structuredClone(props.products)
    setProductsOptions(prOptions)
    setProducts([...updatedProduct]);
  }, [props.products]);

  useEffect(() => {
    if (!props.projects) return;
    let updatedProjects = props?.projects.map((data) => {
      data["checked"] = false;
      return data;
    });
    setProjects([...updatedProjects]);
  }, [props.projects]);

  useEffect(() => {
    if (!props?.templates) return;
    if (props?.alertType?.alertSettings?.alertDesign) {
      props?.templates?.map(temp => {
        if (temp.id === props?.alertType?.alertSettings?.alertDesign?.id) {
          temp.checked = true
        }
      })

      setAlerttemplates([...props?.templates]);
    } else {
      let updatedTemplates = props?.templates.map((data, index) => {
        if (props.alertType.name === "Sales Alert") {
          if (index == 0) {
            data["checked"] = true;
          } else {
            data["checked"] = false;
          }
        } else if (props.alertType.name === "Leads Alert") {
          if (index == 15) {
            data["checked"] = true;
          } else {
            data["checked"] = false;
          }
        } else if (props.alertType.name === "Visitor Alert") {
          if (index == 30) {
            data["checked"] = true;
          } else {
            data["checked"] = false;
          }
        }


        return data;
      });
      // setSelectedAlertDesign(updatedTemplates[0]);
      setAlerttemplates([...updatedTemplates]);
    }

  }, [props.templates]);

  useEffect(() => {
    if (!selectedLeadProject) return;
    getPages1({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: selectedLeadProject, campaign_id: props?.camapaignDetails?.prof_campaign_id })
  }, [selectedLeadProject]);

  useEffect(() => {
    if (!selectedVisitorProject) return;
    getPages1({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: selectedVisitorProject, campaign_id: props?.camapaignDetails?.prof_campaign_id })
  }, [selectedVisitorProject]);

  useEffect(() => {
    const handleOutSideClick = (event) => {
      const isClickedInsideUserBox = event.target.closest(".fp-custom-color-btn");
      // console.log("event", event.target.className)
      // console.log("class", event?.target?.classList)
     
     
      if(event?.target?.classList?.length > 0 
        && !event.target?.classList[0]?.includes("fp-colors") 
        && event?.target?.classList[0] !== "alertMessage" 
        && event?.target?.className
        && event?.target?.className !== "saturation-black" 
        && event.target.className !== "hue-horizontal"
        && event.target.className !== "fp_color_drpdwn alertMessage show_colorPicker"
      ){
        setShowMessageColorOption(false);
        // return
      }

      if(event?.target?.classList?.length>0  
        && !event.target?.classList[0]?.includes("fp-colors") 
        && event?.target?.classList[0] !== "alertTitle" 
        && event?.target?.className
        && event?.target?.className !== "saturation-black" 
       
        && event.target.className !== "hue-horizontal"
         && event.target.className !== "fp_color_drpdwn alertTitle show_colorPicker"
      ){
        setShowAlertColorOption(false);
        // return
      }

      if( 
        event?.target?.classList?.length > 0
        && !event.target?.classList[0]?.includes("core") 
        // && !!event.target.className && event.target.className !== "customColor" 
        // && event.target.className != "core_rbgcpControlBtn__TuOLW" 
        // && event.target.className != "core_ac__pQHU7 core_jsb__Xl021"
        // && event.target.className != "core_rbgcpControlBtn__f6Ilq" 
        // && event.target.className != "core_rbgcpControlBtn__f6Ilq core_rbgcpControlBtnSelected__yb16G" 
        // && event.target.className != "core_rbgcpControlBtn__TuOLW core_rbgcpControlBtnSelected__xcsDN"
        // && event.target.className != "core_rbgcpInputLabel__K16w1"
        // && event.target.className != "core_ac__INnVD core_jsb__u6lJJ"
        // && event.target.className !="core_rbgcpControlBtnWrapper__9RWN0"
        // && event.target.className != "core_rbgcpInputLabel__DTMWD"
        // && event.target.className != "core_rbgcpInput__uzmvL undefined"
        // && event.target.className !="core_rbgcpInput__uzmvL"
        // && event.target.className != "core_rbgcpInput__hqUmD undefined"
        // && event.target.className !="core_rbgcpInput__hqUmD"
      
      ){
        setIsColorPickerOpen(false)
      }

      if( !!event.target.className && event.target.className !== "highlightColor" 
        && event.target.className !== "saturation-black" 
        &&  event.target.className !== "hue-horizontal"
        &&  event.target.className !== "flexbox-fix"){
        setHighlightColorPicker(false)
      }

    };
    window.addEventListener("mousedown", handleOutSideClick);
    return () => {
      window.removeEventListener("mousedown", handleOutSideClick);
    };
  }, [componentRef]);

  const tabIsDisabled = (type) => {

    if (!selectedAlertDesign?.id) {
      return true
    }

    if (selectedAlertDesign?.id) {
      if (props.alertType.name === selectedAlertDesign?.type) {
        // console.log("false", props.alertType.name, selectedAlertDesign?.type)
        // return false
      } else {
        // console.log("true", props.alertType.name, selectedAlertDesign?.type)
        return true
      }
    } else {
      // setActiveTab("productTab")
      // return true
    }


    if (type === "sale") {
      let selectedProducts = products.filter((product) => product.checked);
      return selectedProducts.length == 0 ? true : false
    } else if (type === "lead") {
      let selectedPages = leadPages.filter((page) => page.checked);
      return selectedPages.length.length == 0 ? true : false
    } else if (type === "visitor") {
      let selectedPages = visitorPages.filter((page) => page.checked);
      return selectedPages.length.length == 0 ? true : false
    }
  }

  // const getPages = (formData) => {
  //   let type = { ...formData };
  //   delete formData.type;
  //   PageService.getPages(formData).then((resp) => {
  //     if (resp.data.success) {
  //       // console.log("resp", resp?.data?.page_list)
  //       if (resp?.data?.page_list.length == 0) {
  //         toast.error("Please select another project")
  //         setVisitorPages([])
  //         setLeadPages([]);
  //         return
  //       }
  //       let updatedPages = resp?.data?.page_list.map((data) => {
  //         data["checked"] = false;
  //         return data;
  //       });

  //       if (type?.type === "lead") {
  //         if (props?.alertType?.alertSettings?.pages?.length > 0) {
  //           updatedPages.map(data => {
  //             props?.alertType?.alertSettings?.pages.map(leadPage => {
  //               if (data.funnel_page_id === leadPage.funnel_page_id) {
  //                 data.checked = true
  //               }
  //             })
  //           })
  //         }

  //         setLeadPages(updatedPages);
  //       } else {
  //         if (props?.alertType?.alertSettings?.pages?.length > 0) {
  //           updatedPages.map(data => {
  //             props?.alertType?.alertSettings?.pages.map(leadPage => {
  //               if (data.funnel_page_id === leadPage.funnel_page_id) {
  //                 data.checked = true
  //               }
  //             })
  //           })
  //         }
  //         setVisitorPages(updatedPages);
  //       }
  //     }
  //   }).catch(error => {

  //   });
  // };

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  const handleProductSelection = (value, index) => {
    products[index].checked = value;
    setProducts([...products]);
  };

  const handleProductChange = (selectedOption) => {
    let allSelected = selectedOption[0]
    if (allSelected?.value == "all") {
      let updatedProduct = products.map(product => {
        product.checked = true
        return product;
      });
      setProducts(updatedProduct);
    } else {
      let updatedProduct = products.map(product => {
        const selectedProject = selectedOption.find(option => option.value === product.product_id);
        if (selectedProject) {
          product.checked = true;
        } else {
          product.checked = false;
        }
        return product;
      });
      setProducts(updatedProduct);
    }

  }

  const handlePageSelection = (value, index, type) => {
    if (type === "Leads Alert") {
      let cPage = leadPages[index]
      leadPages[index].checked = value;
      setLeadPages([...leadPages]);
      if (value) {
        selectedLeadPages?.push(leadPages[index])
        setSelectedLeadPages([...selectedLeadPages])
        let isProjectSelected = selectedLeadProjects?.find(item => item == selectedLeadProject)
        if (!isProjectSelected) {
          selectedLeadProjects.push(selectedLeadProject)
          setSelectedLeadProjects([...selectedLeadProjects])
          projects?.map(project => {
            if (project.funnel_id == selectedLeadProject) {
              project.checked = true
            }
          })
          setProjects([...projects])
        }

      } else {
        let currentSelectedPageIndex = selectedLeadPages?.findIndex(page => page.funnel_page_id == cPage?.funnel_page_id)
        selectedLeadPages?.splice(currentSelectedPageIndex, 1)
        setSelectedLeadPages([...selectedLeadPages])
        let isPageSelected = leadPages.find(item => item.checked)
        if (!isPageSelected) {
          let updatedPRojects = selectedLeadProjects.filter(item => item != selectedLeadProject)
          setSelectedLeadProjects(updatedPRojects)
          projects.map(project => {
            if (project.funnel_id == selectedLeadProject) {
              project.checked = false
            }
          })
          setProjects([...projects])
        }
      }

    } else {
      visitorPages[index].checked = value;
      setVisitorPages([...visitorPages]);
      let cPage = visitorPages[index]
      if (value) {
        selectedVisitorPages?.push(visitorPages[index])
        setSelectedVisitorPages([...selectedVisitorPages])
        let isProjectSelected = selectedVisitorPages?.find(item => item == selectedVisitorProject)
        if (!isProjectSelected) {
          selectedVisitorProjects.push(selectedVisitorProject)
          setSelectedVisitorProjects([...selectedVisitorProjects])
          projects.map(project => {
            if (project.funnel_id == selectedVisitorProject) {
              project.checked = true
            }
          })
          setProjects([...projects])
        }
      } else {
        let currentSelectedPageIndex = selectedVisitorPages?.findIndex(page => page.funnel_page_id == cPage?.funnel_page_id)
        selectedVisitorPages?.splice(currentSelectedPageIndex, 1)
        setSelectedVisitorPages([...selectedVisitorPages])
        let isPageSelected = visitorPages?.find(item => item.checked)
        if (!isPageSelected) {
          let updatedPRojects = selectedVisitorProjects?.filter(item => item != selectedVisitorProject)
          setSelectedVisitorProjects(updatedPRojects)
          projects.map(project => {
            if (project.funnel_id == selectedVisitorProject) {
              project.checked = false
            }
          })
          setProjects([...projects])
        }
      }
    }
  };

  const handleAllPageSelection = (val) => {
    if (props.alertType.name === "Leads Alert") {
      leadPages.map(page => {
        page.checked = val
      })
      setLeadPages([...leadPages])
      if (val) {
        leadPages.map(item => {
          let selectedPage = selectedLeadPages?.find(selectedPageItem => selectedPageItem.funnel_page_id == item.funnel_page_id)
          if (!selectedPage) {
            selectedLeadPages.push(item)
          }
        })
        setSelectedLeadPages([...selectedLeadPages])
        let isProjectSelected = selectedLeadProjects?.find(item => item == selectedLeadProject)
        if (!isProjectSelected) {
          selectedLeadProjects.push(selectedLeadProject)
          setSelectedLeadProjects([...selectedLeadProjects])
          projects.map(project => {
            if (project.funnel_id == selectedLeadProject) {
              project.checked = true
            }
          })
          setProjects([...projects])
        }
      } else {
        let updatedLeadPages = selectedLeadPages?.filter(item => item.funnel_id != selectedLeadProject)
        setSelectedLeadPages(updatedLeadPages)
        let updatedPRojects = selectedLeadProjects?.filter(item => item != selectedLeadProject)
        setSelectedLeadProjects(updatedPRojects)
        projects.map(project => {
          if (project.funnel_id == selectedLeadProject) {
            project.checked = false
          }
        })
        setProjects([...projects])

      }
    } else {
      visitorPages?.map(page => {
        page.checked = val
      })
      setVisitorPages([...visitorPages])
      if (val) {
        visitorPages.map(item => {
          let selectedPage = selectedVisitorPages.find(selectedPageItem => selectedPageItem.funnel_page_id == item.funnel_page_id)
          if (!selectedPage) {
            selectedVisitorPages.push(item)
          }
        })
        setSelectedVisitorPages([...selectedVisitorPages])
        let isProjectSelected = selectedVisitorProjects?.find(item => item == selectedVisitorProject)
        if (!isProjectSelected) {
          selectedVisitorProjects.push(selectedVisitorProject)

          projects?.map(project => {
            if (project.funnel_id == selectedVisitorProject) {
              project.checked = true
            }
          })
          setSelectedVisitorProjects([...selectedVisitorProjects])
          setProjects([...projects])
        }
      } else {
        let updatedLeadPages = selectedVisitorPages?.filter(item => item.funnel_id != selectedVisitorProject)
        let updatedPRojects = selectedVisitorProjects?.filter(item => item != selectedVisitorProject)
        projects.map(project => {
          if (project.funnel_id == selectedVisitorProject) {
            project.checked = false
          }
        })
        setSelectedVisitorProjects(updatedPRojects)
        setSelectedVisitorPages(updatedLeadPages)
        setProjects([...projects])
      }


    }

  }

  const handleInputClickEvent = (event) => {
    if (event.name === "alertTitle") {
      const inputElement = inputTitleRef.current;
      let cursorPosition
      setTimeout(() => {
        if (inputElement) {
          cursorPosition = inputElement.selectionStart;
          // console.log('TitleCursor position:', cursorPosition);
        }
      }, 0);

    } else {
      const inputElement = inputMessageRef.current;
      let cursorPosition
      setTimeout(() => {
        if (inputElement) {
          cursorPosition = inputElement.selectionStart;
          // console.log('Message Cursor position:', cursorPosition);
        }
      }, 0);
    }
  }

  const handleInputChange = (event) => {
    if (event.name === "alertTitle") {
      setSelectedAlertDesign((prevState) => ({
        ...prevState,
        [event.name]: {
          ...prevState[event.name],
          shortNote: event.value,
        },
      }));
    } else {
      setSelectedAlertDesign((prevState) => ({
        ...prevState,
        [event.name]: {
          ...prevState[event.name],
          title: event.value,
        },
      }));
    }

    // console.log(event.name, event.value)
  };

  const handleTitlePersonalization = (event) => {
    const inputElement = inputTitleRef.current;
    let cursorPosition = inputElement.selectionStart;
    if (cursorPosition == 0 || cursorPosition) {
      let shortNote = selectedAlertDesign?.alertTitle?.shortNote
      let origString = shortNote?.split('');
      let updatedEv = "[" + event.value + "]"
      origString?.splice(cursorPosition, 0, updatedEv);
      let newString = origString?.join('');
      inputElement.value = newString;
      selectedAlertDesign.alertTitle.shortNote = newString
      setSelectedAlertDesign({ ...selectedAlertDesign })
      let newCursorPosition = cursorPosition + updatedEv.length;
      setTimeout(() => {
        inputElement.focus();
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
      }, 0);
    }
  }

  const handleMessagePersonalization = (event) => {
    const inputElement = inputMessageRef.current;
    let cursorPosition = inputElement.selectionStart;
    let title = selectedAlertDesign?.alertMessage?.title
    let origString = title.split('');
    let updatedEv = "[" + event.value + "]"
    origString.splice(cursorPosition, 0, updatedEv);
    let newString = origString.join('');
    selectedAlertDesign.alertMessage.title = newString
    setSelectedAlertDesign({ ...selectedAlertDesign })
    let newCursorPosition = cursorPosition + updatedEv.length;
    setTimeout(() => {
      inputElement.focus();
      inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  }

  const handleSelectChange = (event) => {
    setSelectedAlertDesign((prevState) => ({
      ...prevState,
      [event.name]: {
        ...prevState[event.name],
        personalization: event.value,
      },
    }));
  };

  const showAlertTitle = (template, type) => {
    if (type) {
      if (template?.alertTitle?.personalization == "firstName") {
        return template?.alertTitle?.firstName;
      } else if (template?.alertTitle?.personalization == "lastName") {
        return template?.alertTitle?.lastName;
      } else if (template?.alertTitle?.personalization == "place") {
        return template?.alertTitle?.place;
      } else if (template?.alertTitle?.personalization == "fullName") {
        return (
          template?.alertTitle?.firstName + " " + template?.alertTitle?.lastName
        );
      }
    } else {
      if (template?.alertMessage?.personalization == "firstName") {
        return template?.alertMessage?.firstName;
      } else if (template?.alertMessage?.personalization == "lastName") {
        return template?.alertMessage?.lastName;
      } else if (template?.alertMessage?.personalization == "place") {
        return template?.alertMessage?.place;
      } else if (template?.alertMessage?.personalization == "fullName") {
        return (
          template?.alertMessage?.firstName +
          " " +
          template?.alertMessage?.lastName
        );
      }
    }
  };

  function replacePlaceholders(str, values) {
    let parts = str?.split(/\[|\]/);
    for (let i = 1; i < parts?.length; i += 2) {
      let placeholder = parts[i];
      if (values.hasOwnProperty("[" + placeholder + "]")) {
        parts[i] = values["[" + placeholder + "]"];
      }
    }
    let replacedStr = parts?.join('');
    replacedStr = replacedStr?.replace(/<\/?h>/g, '');
    return replacedStr;
  }

  const showSelectedProducts = () => {
    let selectedProducts = products
      .filter(product => product.checked)
      .map(selectedProduct => selectedProduct.product_title);
    return selectedProducts;
  }

  const showTempalteShortCode = (template, type) => {
    let values = {
      "[customer_name]": template?.alertTitle?.firstName,
      "[product_name]": "Product",
      "[location]": template?.alertTitle?.place,
      "[city]": template?.alertTitle?.city,
      "[state]": template?.alertTitle?.state,
      "[country]": template?.alertTitle?.country,
      "[time]": template?.alertMessage?.time,
    };
    let result = replacePlaceholders(type ? template?.alertTitle?.shortNote : template?.alertMessage?.title, values);
    return result
  }

  const showSponseredShortCode = (template, type) => {
    let values = {
      "[customer_name]": template?.alertTitle?.firstName,
      "[product_name]": "Product",
      "[location]": template?.alertTitle?.place,
      "[city]": template?.alertTitle?.city,
      "[state]": template?.alertTitle?.state,
      "[country]": template?.alertTitle?.country,
      "[time]": template?.alertMessage?.time,
    };
    let result = replacePlaceholders(template?.sponsoredBy, values);
    return result
  }

  const handleTemplateSelection = (index) => {
    const updatedTemplates = alerttemplates?.map((template, tempIndex) => {
      if (template.type === props?.alertType.name) {
        if (tempIndex === index) {
          setSelectedTemplate(template)
          return { ...template, checked: true };
        } else {
          return { ...template, checked: false };
        }
      } else {
        return template;
      }
    });

    setAlerttemplates([...updatedTemplates]);
  };

  const checkAllSelectedPage = (data) => {
    if (props.alertType.name === "Leads Alert") {
      let isChecked = leadPages?.find(item => !item.checked)
      if (isChecked) {
        return false
      } else {
        return true
      }
    } else {
      let isChecked = visitorPages?.find(item => !item.checked)
      if (isChecked) {
        return false
      } else {
        return true
      }
    }
  }

  const checkAllSelectedProduct = () => {
    let isChecked = products.find(item => !item.checked)
    if (isChecked) {
      return false
    } else {
      return true
    }
  }


  const showIsActive = (type, settting) => {
    if (type === "alertTitle") {
      if (settting?.name === "Bold") {
        return selectedAlertDesign?.alertTitle?.isBold ? "active" : "";
      } else if (settting?.name === "Italic") {
        return selectedAlertDesign?.alertTitle?.isItalic ? "active" : "";
      } else if (settting?.name === "Underline") {
        return selectedAlertDesign?.alertTitle?.isUnderLine ? "active" : "";
      } else if (settting?.name === "Highlight") {
        return selectedAlertDesign?.alertTitle?.isHighlight ? "active" : "";
      }
    } else {
      {
        if (settting?.name === "Bold") {
          return selectedAlertDesign?.alertMessage?.isBold ? "active" : "";
        } else if (settting?.name === "Italic") {
          return selectedAlertDesign?.alertMessage?.isItalic ? "active" : "";
        } else if (settting?.name === "Underline") {
          return selectedAlertDesign?.alertMessage?.isUnderLine ? "active" : "";
        } else if (settting?.name === "Highlight") {
          return selectedAlertDesign?.alertMessage?.isHighlight ? "active" : "";
        }
      }
    }
  };

  const getSelectedPages = (type) => {
    let selectedPages = []
    if (type === "Sales Alert") {
      return selectedPages = salesPages
    } else if (type === "Leads Alert") {
      let newSelectedPages = selectedLeadPages?.filter((pageId, index) => {
        let foundPage = leadPages.find((slPage) => slPage.funnel_page_id === pageId.funnel_page_id && !slPage.checked);
        if (foundPage) {
          return false;
        } else {
          return true;
        }
      });
      let selectePages = [...newSelectedPages, ...leadPages?.filter(page => page.checked)];
      selectePages = selectePages?.filter((page, index, self) => {
        return self.findIndex(p => p.funnel_page_id === page.funnel_page_id) === index;
      });
      if (selectePages) {
        let isProjectPages = selectePages?.some(page => page.funnel_id == selectedLeadProject);
        if (!isProjectPages) {
          let deletedIndex = selectedLeadProjects.findIndex(pr => pr.funnel_id == selectedLeadProject)
          selectedLeadProjects?.splice(deletedIndex, 1)
          setSelectedLeadProjects([...selectedLeadProjects])
        } else {
          selectedLeadProjects.push(selectedLeadProject)
          setSelectedLeadProjects([...selectedLeadProjects])
        }
        // console.log("selectePages",selectePages)
        return selectePages
      }
    } else if (type === "Visitor Alert") {

      // let newSelectedPages = selectedVisitorPages?.filter((pageId, index) => {
      //   let foundPage = visitorPages.find((slPage) => slPage.funnel_page_id === pageId.funnel_page_id && !slPage.checked);
      //   if (foundPage) {
      //     return false; 
      //   } else {
      //     return true;
      //   }
      // });
      // let selectePages = [...newSelectedPages, ...visitorPages?.filter(page => page.checked)];
      // selectePages = selectePages?.filter((page, index, self) => {
      //   return self.findIndex(p => p.funnel_page_id === page.funnel_page_id) === index;
      // });
      // if (selectePages) {
      //   let isProjectPages = selectePages?.some(page => page.funnel_id == selectedVisitorProject);
      //   if (!isProjectPages) {
      //     let deletedIndex = selectedVisitorProjects.findIndex(pr => pr.funnel_id == selectedVisitorProject)
      //     selectedVisitorProjects?.splice(deletedIndex, 1)
      //     setSelectedVisitorProjects([...selectedVisitorProjects])
      //   } else {
      //     selectedVisitorProjects.push(selectedVisitorProjects)
      //     setSelectedVisitorProjects([...selectedVisitorProjects])
      //   }
      //   console.log("selectePages",selectePages)
      //   return selectePages
      // } 


      // console.log("selectedVisitorProject",selectedVisitorProject)
      let newSelectedPages = selectedVisitorPages?.filter((pageId, index) => {
        let foundPage = visitorPages?.find((slPage) => slPage.funnel_page_id === pageId.funnel_page_id && !slPage.checked);
        if (foundPage) {
          return false;
        } else {
          return true;
        }
      });
      let selectePages = [...newSelectedPages, ...visitorPages?.filter(page => page.checked)];
      selectePages = selectePages?.filter((page, index, self) => {
        return self.findIndex(p => p.funnel_page_id === page.funnel_page_id) === index;
      });
      if (selectePages) {
        let isProjectPages = selectePages?.some(page => page.funnel_id == selectedVisitorProject);
        if (!isProjectPages) {
          let deletedIndex = selectedVisitorProjects.findIndex(pr => pr.funnel_id == selectedVisitorProject)
          selectedVisitorProjects.splice(deletedIndex, 1)
          setSelectedVisitorProjects([...selectedVisitorProjects])
        } else {
          selectedVisitorProjects.push(selectedVisitorProject)
          setSelectedVisitorProjects([...selectedVisitorProjects])
        }

        // console.log("selectePages",selectePages)

        return selectePages
      }

    }
  }

  const getAlertTypeData = (type) => {
    if (type == "Sales Alert") {
      return "sale"
    } else if (type == "Leads Alert") {
      return "lead"
    } else if (type == "Visitor Alert") {
      return "visitor"
    }

  }

  const getFunnelId = (type) => {
    if (type === "Sales Alert") {
      return selectedSalesProject
    } else if (type === "Leads Alert") {
      let selectedPr = selectedLeadProjects?.filter((page, index, self) => {
        return page !== undefined && self.findIndex(p => p === page) === index;
      });
      return selectedPr
    } else if (type === "Visitor Alert") {
      // console.log("selectedVisitorProject", selectedVisitorProject)
      let selectedPr = selectedVisitorProjects?.filter((page, index, self) => {
        return page !== undefined && self.findIndex(p => p === page) === index;
      });
      // console.log("selectedPr", selectedPr)
      return selectedPr
    }
  }

  const getSelectedPageIds = (type) => {
    let selectedPages = []
    if (type === "Sales Alert") {
      return selectedPages = salesPages
    } else if (type === "Leads Alert") {
      let newSelectedPages = selectedLeadPages?.filter((pageId, index) => {
        let foundPage = leadPages.find((slPage) => slPage.funnel_page_id === pageId.funnel_page_id && !slPage.checked);
        if (foundPage) {
          return false;
        } else {
          return true;
        }
      });

      let selectePages = [...newSelectedPages, ...leadPages?.filter(page => page.checked)];
      selectePages = selectePages?.filter((page, index, self) => {
        return self.findIndex(p => p.funnel_page_id === page.funnel_page_id) === index;
      });
      return selectePages.map(page => page.funnel_page_id)
    } else if (type === "Visitor Alert") {
      let newSelectedPages = selectedVisitorPages?.filter((pageId, index) => {
        let foundPage = visitorPages.find((slPage) => slPage.funnel_page_id === pageId.funnel_page_id && !slPage.checked);
        if (foundPage) {
          return false;
        } else {
          return true;
        }
      });
      let selectePages = [...newSelectedPages, ...visitorPages?.filter(page => page.checked)];
      selectePages = selectePages?.filter((page, index, self) => {
        return self.findIndex(p => p.funnel_page_id === page.funnel_page_id) === index;
      });
      return selectePages.map(page => page.funnel_page_id)
    }
  }

  const saveSalesAlert = () => {
    let selectedProducts = products.filter((product) => product.checked);
    let selectedPages = getSelectedPages(props?.alertType?.name);
    if (props?.alertType?.name === "Sales Alert" && selectedProducts?.length == 0) {
      toast.error('Please select product');
      return
    } else if (props?.alertType?.name !== "Sales Alert" && selectedPages?.length == 0) {
      toast.error('Please select pages');
      return
    }

    let selectedTypeTemplates = alerttemplates?.filter(template => template.type === props?.alertType?.name)

    let selectedTemplates = selectedTypeTemplates.find((template) => template.checked);

    if (selectedTemplates && selectedTemplates.id !== selectedAlertDesign?.id) {
      setSelectedAlertDesign({ ...selectedTemplates })
    }

    let updateObj = {
      alertType: getAlertTypeData(props?.alertType?.name),
      products: selectedProducts,
      pages: selectedPages,
      funnel_id: getFunnelId(props?.alertType?.name),
      funnel_page_id: getSelectedPageIds(props?.alertType?.name),
      templates: selectedTemplates,
      alertDesign: selectedTemplates?.id !== selectedAlertDesign?.id ? selectedTemplates : selectedAlertDesign,
      prof_campaigns_setting_id: props?.alertType?.alertSettings?.prof_campaigns_setting_id
    };

    // console.log("updateObj", updateObj)

    // return

    if (props?.alertType.name === "Sales Alert") {
    } else {
      delete updateObj.products;
    }
    if (activeTab === "productTab") {
      props.handleSaveAlert(updateObj);
      setActiveTab("dfyTemplatesTab");
    } else if (activeTab === "dfyTemplatesTab") {
      props.handleSaveAlert(updateObj);
      setActiveTab("designTab");
    }
  };

  const updateAlerts = () => {
    let selectedProducts = products.filter((product) => product.checked);
    let selectedPages = getSelectedPages(props?.alertType?.name);
    if (props?.alertType?.name === "Sales Alert" && selectedProducts.length == 0) {
      toast.error('Please select product');
      return
    } else if (props?.alertType?.name !== "Sales Alert" && selectedPages.length == 0) {
      toast.error('Please select pages');
      return
    }

    let selectedTypeTemplates = alerttemplates?.filter(template => template.type === props?.alertType?.name)

    let selectedTemplates = selectedTypeTemplates.find((template) => template.checked);

    if (selectedTemplates && selectedTemplates.id !== selectedAlertDesign?.id) {
      setSelectedAlertDesign({ ...selectedTemplates })
    }

    let updateObj = {
      alertType: getAlertTypeData(props?.alertType?.name),
      products: selectedProducts,
      pages: selectedPages,
      funnel_id: getFunnelId(props?.alertType?.name),
      funnel_page_id: getSelectedPageIds(props?.alertType?.name),
      templates: selectedTemplates,
      alertDesign: selectedTemplates?.id !== selectedAlertDesign?.id ? selectedTemplates : selectedAlertDesign,
      prof_campaigns_setting_id: props?.alertType?.alertSettings?.prof_campaigns_setting_id
    };

    if (props?.alertType.name === "Sales Alert") {
    } else {
      delete updateObj.products;
    }
    if (activeTab === "productTab") {
      updateObj["isSave"] = true
      props.handleSaveAlert(updateObj);
      setActiveTab("dfyTemplatesTab");
    } else if (activeTab === "dfyTemplatesTab") {
      updateObj["isSave"] = true
      props.handleSaveAlert(updateObj);
      setActiveTab("designTab");
    }
  }

  const saveDesign = () => {

    let selectedProducts = products.filter((product) => product.checked);
    let selectedTypeTemplates = alerttemplates?.filter(template => template.type === props?.alertType?.name)



    let selectedPages = getSelectedPages(props?.alertType?.name);

    if (props?.alertType?.name === "Sales Alert" && selectedProducts.length == 0) {
      toast.error('Please select product');
      return
    } else if (props?.alertType?.name !== "Sales Alert" && selectedPages.length == 0) {
      toast.error('Please select pages');
      return
    }

    selectedAlertDesign.alertTitle.color = alertTitleColor
    selectedAlertDesign.alertMessage.color = alertMessageColor

    let updateObj = {
      alertType: getAlertTypeData(props?.alertType?.name),
      products: selectedProducts,
      pages: selectedPages,
      funnel_id: getFunnelId(props?.alertType?.name),
      funnel_page_id: getSelectedPageIds(props?.alertType?.name),
      templates: selectedAlertDesign,
      alertDesign: selectedAlertDesign,
      prof_campaigns_setting_id: props?.alertType?.alertSettings?.prof_campaigns_setting_id
    };

    setSelectedAlertDesign({ ...selectedAlertDesign })

    if (props?.alertType.name === "Sales Alert") {

    } else {
      delete updateObj.products;
    }
    props.handleSaveAlert(updateObj);
    if (activeTab === "designTab") {
      props.handleSaveAlert(updateObj);
      setActiveTab("behaviorTab");
    } if (activeTab === "behaviorTab") {
      updateObj["isSave"] = true
      updateObj["isBehaviour"] = true
      props.handleSaveAlert(updateObj);
    }
  };

  const updateDesign = () => {
    let selectedProducts = products.filter((product) => product.checked);
    let selectedTypeTemplates = alerttemplates?.filter(template => template.type === props?.alertType?.name)

    let selectedPages = getSelectedPages(props?.alertType?.name);

    selectedAlertDesign.alertTitle.color = alertTitleColor
    selectedAlertDesign.alertMessage.color = alertMessageColor

    let updateObj = {
      alertType: getAlertTypeData(props?.alertType?.name),
      products: selectedProducts,
      pages: selectedPages,
      funnel_id: getFunnelId(props?.alertType?.name),
      funnel_page_id: getSelectedPageIds(props?.alertType?.name),
      templates: selectedAlertDesign,
      alertDesign: selectedAlertDesign,
      prof_campaigns_setting_id: props?.alertType?.alertSettings?.prof_campaigns_setting_id
    };

    setSelectedAlertDesign({ ...selectedAlertDesign })

    if (props?.alertType.name === "Sales Alert") {

    } else {
      delete updateObj.products;
    }
    props.handleSaveAlert(updateObj);
    if (activeTab === "designTab") {
      updateObj["isSave"] = true
      props.handleSaveAlert(updateObj);
      setActiveTab("behaviorTab");
    } if (activeTab === "behaviorTab") {
      updateObj["isSave"] = true
      updateObj["isBehaviour"] = true
      props.handleSaveAlert(updateObj);
    }
  };

  const handleSettingSelection = (type, setting) => {
    if (type === "alertMessage") {
      setSelectedAlertDesign((prevState) => ({
        ...prevState,
        alertMessage: {
          ...prevState.alertMessage,
          [setting]: !prevState.alertMessage[setting],
        },
      }));
    } else {
      setSelectedAlertDesign((prevState) => ({
        ...prevState,
        alertTitle: {
          ...prevState.alertTitle,
          [setting]: !prevState.alertTitle[setting],
        },
      }));
    }
  };

  const handleSocialUrlInput = (value, key) => {
    selectedAlertDesign.socialMediaUrls[key] = value;
    setSelectedAlertDesign({ ...selectedAlertDesign });
  };

  const handleGrediantColor = (colorValue) => {
    setColor(colorValue);
    setSelectedAlertDesign({ ...selectedAlertDesign, gradientColor: colorValue })
  };

  const handleAllProjectSelection = (value) => {
    products.map(product => {
      product.checked = value
    })
    setProducts([...products])
  };

  const checkboxIsVisible = () => {
    if (props?.alertType?.name === "Sales Alert") {
      // products.

    } else if (props?.alertType?.name === "Leads Alert") {
      return leadPages?.length > 1 ? true : false
    } else if (props?.alertType?.name === "Visitor Alert") {
      return visitorPages?.length > 1 ? true : false
    }
  }

  const handleUploadImage = (event) => {
    setIsImageUploading(true)
    uploadImage(event.target.files[0], selectedAlertDesign)
  }

  const uploadImage = (file, alertType) => {
    let newFormData = new FormData()
    newFormData.append("userId", userDetails.user.id)
    newFormData.append("token", userDetails.token)
    newFormData.append("width", 540)
    newFormData.append("height", 1180)
    newFormData.append("type", file.type)
    newFormData.append("name", file.name)
    newFormData.append("file", file)
    newFormData.append("cloud_type", 2)
    newFormData.append("upload_type", 3)
    newFormData.append("template_id", alertType.id)
    CampaignService.uploadImage(newFormData).then((resp) => {
      // console.log()
      if (resp.status == 200) {
        toast.success(resp.data.message)
        setIsImageUploading(false)
        // selectedAlertDesign['uploadedImage'] = resp.data.results
        if (selectedAlertDesign.type === "Visitor Alert") {
          if (templateType == "icon") {
            selectedAlertDesign.IconImg = resp.data.results.imgUrl
          } else {
            selectedAlertDesign.tempImg = resp.data.results.imgUrl
          }
        } else {
          selectedAlertDesign.tempImg = resp.data.results.imgUrl
        }
        setSelectedAlertDesign({ ...selectedAlertDesign })
        setUploadImageModel(false)
        saveImageLibrary({ user_id: userDetails.user.id, token: userDetails.token, img_path: resp.data.results.imgUrl })
      } else {
        toast.error(resp.data.message)
        setIsImageUploading(false)
        setUploadImageModel(false)
      }
    }).catch(error => {
      setIsImageUploading(false)
      setUploadImageModel(false)
      toast.error(error.message)
    });;


  }

  const saveImageLibrary = (formData) => {
    CampaignService.saveImagelibrary(formData).then((resp) => {
      getImagelibrary({ user_id: userDetails.user.id, token: userDetails.token, page: page })
    }).catch(error => {
    });
  }

  const getImagelibrary = (formData) => {
    CampaignService.getImagelibrary(formData).then((resp) => {
      if (resp.status == 200) {
        setImageLibraryList(resp.data.library_img_list)
        setTotalPages(resp.data.total_pages)
        setimageLoading(false)
      } else {
        console.log("error", resp)
      }
    }).catch(error => {
      console.log("error", error)
    });
  }

  const showImage = (alertSettings) => {
    if (alertSettings?.type === "Visitor Alert") {
      if (templateType === "icon") {
        return alertSettings?.IconImg
      } else {
        return alertSettings?.tempImg
      }
      //  }
    } else {
      return alertSettings?.tempImg
    }
  }

  const showVisitorsTemplates = (template) => {
    if (template.type === "Visitor Alert" && templateType === "image") {
      return `${template?.tempImg}`
    } else {
      return `${template?.IconImg}`
    }
  }

  const debouncedSetTemplateType = debounce(newTemplateType => {
    setTemplateType(newTemplateType);
    selectedAlertDesign.templatetype = newTemplateType
    setSelectedAlertDesign({ ...selectedAlertDesign })
  }, 200);

  const handleAlertTilte = (colorCode) => {
    setAlertTitleColor(colorCode)
  }

  const handleAlertMessage = (colorCode) => {
    setAlertMessageColor(colorCode)
  }

  const handleProjectSelection = (value) => {
    setSelectedLeadProject(value)
    setSelectedVisitorProject(value)
  }

  const handleImageData = () => {
    setUploadImageModel(true)
  }

  const handleOptions = (name, options) => {
    let newList = [];
    if (name == "products") {
      options?.map(option => {
        let data = {
          value: option?.product_id,
          label: option?.product_title,
          checked: option?.checked,
        }
        newList.push(data)
        // }

      })
      return newList
    }
  }

  const showDefaultOption1 = (name, options) => {
    let newList = [];
    if (name == "products") {
      let filterOption = options?.filter(option => option.checked)
      filterOption?.map(option => {
        if (option?.value == "all") {
          newList.push(option)
        } else {
          let data = {
            value: option?.product_id,
            label: option?.product_title,
            // checked: option?.checked,
          }
          newList.push(data)
        }
      })
      return newList
    }
  }

  const getProjectAndPages = async (funnelIds, funnelPageIds, projectList) => {
    if (funnelIds?.length == 0 || funnelPageIds?.length == 0 || projectList?.length == 0) {
      return
    }

    if (!Array.isArray(funnelIds)) {
      console.error("funnelIds is not an array");
      return;
    }

    if (!Array.isArray(funnelPageIds)) {
      console.error("funnelPageIds is not an array");
      return;
    }

    const selectedProjectList = await projectList?.filter(project =>
      funnelIds?.some(id => project.funnel_id == id)
    );

    let Selectedpages1 = []

    if (selectedProjectList?.length > 0 && funnelIds?.length > 0 && funnelPageIds?.length > 0) {
      selectedProjectList?.map(project => {
        let projectsPages = getProjectPages({ user_id: userDetails.user.id, token: userDetails.token, funnel_id: project?.funnel_id, campaign_id: props?.camapaignDetails?.prof_campaign_id })
        let Selectedpages = []
        projectsPages.then(pages => {
          pages?.map(page => {
            funnelPageIds.length > 0 && funnelPageIds?.map(id => {
              if (page.funnel_page_id == id) {
                page.checked = true
                Selectedpages.push(page)
                project["pages"] = Selectedpages
                Selectedpages1.push(page)
              }
            })
          })
          if (props?.alertType.name == "Leads Alert") {
            // console.log(Selectedpages1)
            setSelectedLeadPages(Selectedpages1)
            setSelectedLeadProject(selectedProjectList[selectedProjectList?.length - 1]?.funnel_id)
          } else {
            setSelectedVisitorPages(Selectedpages1)
            setSelectedVisitorProject(selectedProjectList[selectedProjectList?.length - 1]?.funnel_id)
          }
        })

      })


      if (props?.alertType?.name == "Leads Alert") {
        let updatedProjects = projectList?.map(pr => {
          const selectedProject = selectedProjectList?.find(slPR => slPR.funnel_id === pr.funnel_id);
          if (selectedProject) {
            pr["checked"] = true;
          } else {
            pr["checked"] = false;
          }
          return pr;
        });

        let selectedProjectList1 = selectedProjectList.map(pr => pr.funnel_id)
        setSelectedLeadProjects(selectedProjectList1)
        setProjects(updatedProjects)
        // setSelectedLeadProject(selectedProjectList[selectedProjectList?.length - 1]?.funnel_id)
      } else if (props?.alertType.name == "Visitor Alert") {
        let updatedProjects = projectList?.map(pr => {
          const selectedProject = selectedProjectList?.find(slPR => slPR.funnel_id === pr.funnel_id);
          if (selectedProject) {
            pr["checked"] = true;
          } else {
            pr["checked"] = false;
          }
          return pr;
        });
        let selectedProjectList1 = selectedProjectList.map(pr => pr.funnel_id)
        setSelectedVisitorProjects(selectedProjectList1)
        setProjects(updatedProjects)
        // setSelectedVisitorProject(selectedProjectList[selectedProjectList?.length - 1]?.funnel_id)
      }
      return selectedProjectList[selectedProjectList?.length - 1]
    }
  }

  const getPages1 = (formData) => {
    PageService.getPages(formData).then(async resp => {
      if (resp.data.success) {
        if (resp?.data?.page_list?.length == 0) {
          toast.error('Please select another project.');
          setLeadPages([]);
          setVisitorPages([])
        }

        let updatedPages1 = resp?.data?.page_list?.map(page => {
          page.checked = false
          return page
        })

        let updatedPages = structuredClone(updatedPages1)
        // let selectedProjectPages = await props?.alertType?.alertSettings && typeof props?.alertType?.alertSettings.funnel_page_id == "string" ? JSON.parse(props?.alertType?.alertSettings?.funnel_page_id) : props?.alertType?.alertSettings?.funnel_page_id 
        // console.log("selectedProjectPages", selectedProjectPages)
        // console.log("selectedLeadPages", selectedLeadPages)
        // if (props?.alertType?.alertSettings?.funnel_page_id?.length > 0) {
        //   updatedPages?.map(data => {
        //     selectedProjectPages?.map(leadPage => {
        //       if (data.funnel_page_id === leadPage) {
        //         data.checked = true
        //       }
        //     })
        //   })
        // }

        if (props?.alertType?.value === "lead") {
          if (selectedLeadPages?.length > 0) {
            updatedPages?.map(data => {
              selectedLeadPages?.map(leadPage => {
                if (data.funnel_page_id === leadPage.funnel_page_id) {
                  data.checked = true
                }
              })
            })
          }
          setLeadPages(updatedPages);
        } else {
          if (selectedVisitorPages?.length > 0) {
            updatedPages?.map(data => {
              selectedVisitorPages?.map(visitorPage => {
                if (data.funnel_page_id === visitorPage.funnel_page_id) {
                  data.checked = true
                }
              })
            })
          }
          setVisitorPages(updatedPages);
        }

      }

    }).catch(error => {

    });

  }

  const getPages = (formData) => {

    let type = { ...formData };

    delete formData.type;

    PageService.getPages(formData).then((resp) => {

      if (resp.data.success) {

        // console.log("resp", resp?.data?.page_list)

        if (resp?.data?.page_list.length == 0) {

          toast.error("Please select another project")

          setVisitorPages([])

          setLeadPages([]);

          return

        }

        let updatedPages = resp?.data?.page_list.map((data) => {

          data["checked"] = false;

          return data;

        });



        if (type?.type === "lead") {

          if (props?.alertType?.alertSettings?.pages?.length > 0) {

            updatedPages.map(data => {

              props?.alertType?.alertSettings?.pages.map(leadPage => {

                if (data.funnel_page_id === leadPage.funnel_page_id) {

                  data.checked = true

                }

              })

            })

          }



          setLeadPages(updatedPages);

        } else {

          if (props?.alertType?.alertSettings?.pages?.length > 0) {

            updatedPages.map(data => {

              props?.alertType?.alertSettings?.pages.map(leadPage => {

                if (data.funnel_page_id === leadPage.funnel_page_id) {

                  data.checked = true

                }

              })

            })

          }

          setVisitorPages(updatedPages);

        }

      }

    }).catch(error => {



    });

  };

  const getProjectPages = (formData) => {
    return new Promise((resolve, reject) => {
      PageService.getPages(formData)
        .then((resp) => {
          if (resp.data.success) {
            let updatedPages = structuredClone(resp?.data?.page_list)
            resolve(updatedPages);
          } else {
            reject(new Error("Failed to fetch pages"));
          }
        }).catch(error => {
          // reject(error);
          reject(new Error("Failed to fetch pages"));
        });
    });

  }

  const handleProjectOption = (options) => {
    let newList = [];
    options?.map(option => {
      let data = {
        value: option?.funnel_id,
        label: option?.name,
        checked: option.checked,
      }
      newList.push(data)
    })
    return newList
  }

  const handleProjectChange = (value) => {
    if (!value) return
    props?.alertType.name === "Leads Alert" ? setSelectedLeadProject(value) : setSelectedVisitorProject(value)
  }

  const showDefaultOption = () => {
    if (props?.alertType.name === "Leads Alert") {
      return selectedLeadProject || ""
    } else {
      return selectedVisitorProject || ""
    }
  }

  const showPagesOptions = (type) => {
    if (!type) return;
    if (type === "Leads Alert") {
      return leadPages;
    } else {
      return visitorPages;
    }
  };

  const showSelectedProjects = () => {
    if (selectedAlertDesign?.type == "Leads Alert") {
      return selectedLeadProject
    } else {
      return selectedVisitorProject
    }
  }

  const showProjectName = () => {
    if (props?.alertType?.name == "Leads Alert") {
      const selectedPR = projects.filter(element => selectedLeadProjects.includes(element.funnel_id));
      let names = selectedPR?.map(item => item.name).join(', ');
      return names ? "(" + names + ")" : ""
    } else {
      const selectedPR = projects.filter(element => selectedVisitorProjects.includes(element.funnel_id));
      let names = selectedPR?.map(item => item.name).join(', ');
      return names ? "(" + names + ")" : ""
    }
  }

  const showPlaceholder = () => {
    if (selectedAlertDesign.type == "Sales Alert") {
      return "Customer Name, India"
    } else if (selectedAlertDesign.type == "Leads Alert") {
      return "Customer Name, India"
    } else if (selectedAlertDesign.type == "Visitor Alert") {
      return " A Visitor from, India"
    }
  }

  const showMessagePlaceholder = () => {
    if (selectedAlertDesign.type == "Sales Alert") {
      return "Purchased the product 2 minutes ago."
    } else if (selectedAlertDesign.type == "Leads Alert") {
      return "Subscribed to the newsletter 2 minutes ago."
    } else if (selectedAlertDesign.type == "Visitor Alert") {
      return "Viewed this page 2 minutes ago."
    }
  }

  const showProducts = () => {
    return (
      <div className="fp-create-camp-body">
        <div className="fp-alert-settings fp-product-settings">
          <h4 className="fp-subtitle">
            Select Products
            <div className="info-tooltip">
              <img src="https://img.flexifunnels.com/flexiproof-assets/info.svg" alt="" />
              <span className="data">
                Select the products from which you want to retrieve the sales records.
              </span>
            </div>
          </h4>
          <div className="fp_selectAll">
            <input
              type="checkbox"
              id="selectAll"
              checked={checkAllSelectedProduct()}
              onChange={(e) => handleAllProjectSelection(e.target.checked)}
            />
            <label htmlFor="selectAll">
              <span></span>
              Select All
            </label>
          </div>
          <div className="fp-input-wrap  fp_multi_select_option">
            <MultiSelectAutoComplete
              name="productIds"
              options={products?.length > 0 && handleOptions("products", products) || []}
              handleOnChange={handleProductChange}
              defaultOptions={products?.length > 0 && showDefaultOption1("products", products) || []}
              placeholder="Select Products"
            />
          </div>

          {/* <div className="fp-product-settings-list">
            <ul>
              {products?.map((product, pIndex) => {
                return (
                  <li key={`product_${pIndex}`}>
                    <input
                      type="checkbox"
                      id={product.product_id}
                      checked={product?.checked}
                      onChange={(e) =>
                        handleProductSelection(e.target.checked, pIndex)
                      }
                    />
                    <label htmlFor={product.product_id}>
                      <span></span>
                      {product?.product_title}
                    </label>
                  </li>
                );
              })}
            </ul>
          </div> */}

          {/* updateAlerts */}
          <div className="fp-btn-wrap fp-creat-camp">
            <a className="fp-btn" onClick={() => saveSalesAlert()}>
              Next
            </a>
            {props?.alertType?.alertSettings?.prof_campaigns_setting_id && <a className="fp-btn" onClick={() => updateAlerts()}>
              save
            </a>}
          </div>
        </div>
      </div>
    );
  };

  const showTemplates = () => {
    return (
      <div className="fp-create-camp-body">
        <div className="fp-alert-settings fp-template-settings">
          <h4 className="fp-subtitle">DFY Templates</h4>
          {/* {props.alertType.value === "visitor" && <div className="fp_visitor_radio_btns">
            <div className="fp-radio-btn">
              <input type="radio" name="radio" value={templateType} checked={templateType === "icon"} onChange={() => debouncedSetTemplateType("icon")} />
              <label>
              <span></span>
                Icon                
              </label>
            </div>
            <div className="fp-radio-btn">
              <input type="radio" name="radio" value={templateType} checked={templateType === "image"} onChange={() => debouncedSetTemplateType("image")} />
              <label>
              <span></span>
                Map              
              </label>
            </div>
          </div>} */}
          <div className="fp-template-wrapper">
            {alerttemplates?.map((template, index) => {
              if (template?.type !== props?.alertType?.name) return null;
              return (
                <div key={`template_${index}`} className={`fp-template-box ${template?.class}`} onClick={() => handleTemplateSelection(index)}>
                  <div className="fp-inline-checkbox">
                    <input
                      className="fp-checkbox"
                      type="radio"
                      checked={template?.checked}
                      readOnly
                    // onChange={() => handleTemplateSelection(index)}
                    />
                    <span className="fp-checkbox-icon"></span>
                  </div>
                  <div className="fp-alert-widget-box">
                    <div className="fp-widget-box ">
                      <span className="fp-widget-style1 "></span>
                      <span className="fp-widget-styletwo "></span>

                      <div className="fp_widget_box_inner">
                        <span className={`fp-widget-icon`}>
                          <img src={template.type === "Visitor Alert" ? showVisitorsTemplates(template, templateType) : template?.tempImg} alt="" />
                        </span>
                        <div className="fp-widget-content">
                          <h5>{showTempalteShortCode(template, true)}</h5>
                          <p>{showTempalteShortCode(template, false)}</p>
                          {/* <p>{template.alertMessage.title}</p> */}
                          <div className="fp-widget-info">
                            <span>{template?.alertMessage?.time}</span>
                            <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1" /></g></svg>
                            <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />
                            <span>{showSponseredShortCode(template)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="fp-btn-wrap fp-creat-camp mt-3">
            <a className="fp-btn" onClick={() => saveSalesAlert()}>
              Next
            </a>
            {props?.alertType?.alertSettings?.prof_campaigns_setting_id && <a className="fp-btn" onClick={() => updateAlerts()}>
              save
            </a>}
          </div>
        </div>
      </div>
    );
  };

  const showPages = () => {
    return (
      <div className="fp-create-camp-body">
        <div className="fp-alert-settings fp-product-settings">
          <div className="fp-input-wrap fp_page_select">
            <h4 className="fp-subtitle">
              Choose Project
              <div className="info-tooltip">
                <img src="https://img.flexifunnels.com/flexiproof-assets/info.svg" alt="" />
                <span className="data">
                  {props?.alertType?.name === "Leads Alert" ? " Select the project and pages from which you want to retrieve the lead records." :
                    "Select the project and pages from which you want to retrieve the visitor records."}
                </span>
              </div>
            </h4>
            <Multiselect
              options={projects?.length > 0 && handleProjectOption(projects) || []}
              defaultValue={projects?.length > 0 && showSelectedProjects() || ""}
              onChangeCallBAck={handleProjectChange}
            />

            <div className="fsSlectProjct">
              <p>{showProjectName()}</p>
            </div>
          </div>
          {checkboxIsVisible() &&
            <>
              <h4 className="fp-subtitle">
                Choose  Pages
                {/* <div className="info-tooltip">
                  <img src="https://img.flexifunnels.com/flexiproof-assets/info.svg" alt="" />
                  <span className="data">
                    info alert type msg will be show here
                  </span>
                </div> */}
              </h4>

              <div className="fp_selectAll">
                <input
                  type="checkbox"
                  id="selectAll"
                  checked={checkAllSelectedPage()}
                  onChange={(e) => handleAllPageSelection(e.target.checked)}
                />
                <label htmlFor="selectAll">
                  <span></span>
                  Select All
                </label>
              </div> </>}
          <div className="fp-product-settings-list">
            <ul>
              {showPagesOptions(props?.alertType.name)?.map((page, pIndex) => {
                return (
                  <li key={`pages_${pIndex}`}>
                    <input
                      type="checkbox"
                      id={page?.funnel_page_id}
                      checked={page?.checked}
                      onChange={(e) =>
                        handlePageSelection(
                          e.target.checked,
                          pIndex,
                          props?.alertType.name
                        )
                      }
                    />
                    <label htmlFor={page?.funnel_page_id}>
                      <span></span>
                      {page?.name}
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="fp-btn-wrap fp-creat-camp">
            <a className="fp-btn" onClick={() => saveSalesAlert()}>
              Next
            </a>
            {props?.alertType?.alertSettings?.prof_campaigns_setting_id && <a className="fp-btn" onClick={() => updateAlerts()}>
              save
            </a>}
          </div>
        </div>
      </div>
    );
  };

  const showDesign = () => {
    return (
      <div className="fp-create-camp-body">
        <div className="fp-alert-settings fp-template-settings fp-temp-design">
          <h4 className="fp-subtitle">Design</h4>
          <div className="fp-alert-design-settings">
            <div className="fp-alert-design-controls">
              {/* Alert Title  */}
              <div className="fp-multioption-field mb-40">
                <h4 className="fp-subtitle">Alert Title</h4>
                <div className="fp-multifield">
                  <div className="fp-input-group">
                    <input
                      type="text"
                      placeholder={showPlaceholder()}
                      name="alertTitle"
                      value={selectedAlertDesign?.alertTitle?.shortNote || ""}
                      onClick={(e) => handleInputClickEvent(e.target)}
                      onChange={(e) => handleInputChange(e.target)}
                      ref={inputTitleRef}
                    />
                    <div className="fp-alrt-settings">
                      <select
                        name="alertTitle"
                        id=""
                        value={selectedAlertDesign?.alertTitle?.personalization}
                        onChange={(e) => handleTitlePersonalization(e.target)}
                      >
                        <option value="">Add Personalization</option>
                        {selectedAlertDesign?.type !== "Visitor Alert" && <option value="customer_name">Customer Name</option>}
                        {selectedAlertDesign?.type === "Sales Alert" && <option value="product_name">Product Name</option>}
                        {/* <option value="location">Location</option> */}
                        <option value="city">City</option>
                        {selectedAlertDesign?.type !== "Visitor Alert" && <option value="state">State</option>}
                        <option value="country">Country</option>

                      </select>
                      <ul>
                        {AlertTypeDesignSetting.map((settingType, index) => {
                          if (index == 3) {
                            return (
                              <div key={`settingType${index}`} className={alertTitleColor ? "fp-custom-color-btn active fpShowColorPicker" : "fp-custom-color-btn fpShowColorPicker"}>
                                <span  className="alertTitle" onClick={() => setShowAlertColorOption(!showAlertColorOption)}>
                                  {svg.app.textcolorIcon1}
                                </span>
                                <div className={showAlertColorOption ? "fp_color_drpdwn alertTitle show_colorPicker " : "fp_color_drpdwn "}>
                                  <ul>
                                    {HighlightColors.map((highlightedColor, colorIndex) => {
                                      return (
                                        <li key={`color_${colorIndex}`}>
                                          <span
                                            className={`fp-colors ${highlightedColor.label}`}
                                            style={{
                                              boxShadow:
                                                highlightedColor.value === highlightColor
                                                  ? "rgb(204, 204, 204) 2px 2px 3px 2px"
                                                  : "",
                                            }}
                                            onClick={() => { handleAlertTilte(highlightedColor.value) }}
                                          ></span>
                                        </li>
                                      );
                                    })}
                                    
                                  </ul>
                                  <ChromePicker
                                      color={alertTitleColor}
                                      disableAlpha = {true}
                                      onChangeComplete={(color) =>{ setAlertTitleColor(color.hex)}}
                                    />
                                  {/* <div className={`fp-custom-color-btn ${IsAlertTitlePicker && "fpShowColorPicker"} fpShowColorPicker fp_title_color`}>
                                    <input
                                      type="color"
                                      onChange={(e) => setAlertTitleColor(e.target.value)}
                                      value={alertTitleColor}
                                    />

                                    <ChromePicker
                                      color={alertTitleColor}
                                      disableAlpha = {true}
                                      onChangeComplete={(color) =>{ setAlertTitleColor(color.hex)}}
                                    />
                                  
                                    <span onClick={() => setIsAlertTitlePicker(!IsAlertTitlePicker)}>
                                      {svg.app.editIcon}
                                      Custom Colour
                                    </span>
                                  </div> */}
                                  
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <li key={`alertTitle_${index}`}>
                                <a
                                  className={`${settingType?.className
                                    } fp-has-tooltip ${showIsActive(
                                      "alertTitle",
                                      settingType
                                    )}`}
                                  onClick={() =>
                                    handleSettingSelection(
                                      "alertTitle",
                                      settingType.value
                                    )
                                  }
                                >
                                  {settingType?.icon}
                                  <div className={`fp-tooltip-info`}>
                                    {settingType?.name}
                                  </div>
                                </a>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Alert Message  */}

              <div className="fp-multioption-field mb-40">
                <h4 className="fp-subtitle">Alert Message</h4>
                <div className="fp-multifield">
                  <div className="fp-input-group">
                    <input
                      type="text"
                      placeholder={showMessagePlaceholder()}
                      name="alertMessage"
                      value={selectedAlertDesign?.alertMessage?.title || ""}
                      onClick={(e) => handleInputClickEvent(e.target)}
                      onChange={(e) => handleInputChange(e.target)}
                      ref={inputMessageRef}
                    />
                    <div className="fp-alrt-settings">
                      <select
                        name="alertMessage"
                        id=""
                        value={
                          selectedAlertDesign?.alertMessage?.personalization
                        }
                        onChange={(e) => handleMessagePersonalization(e.target)}
                      >
                        <option value="">Add Personalization</option>
                        {selectedAlertDesign?.type !== "Visitor Alert" && <option value="customer_name">Customer Name</option>}
                        {selectedAlertDesign?.type === "Sales Alert" && <option value="product_name">Product Name</option>}
                        {/* <option value="location">Location</option> */}
                        <option value="city">City</option>
                        {selectedAlertDesign?.type !== "Visitor Alert" && <option value="state">State</option>}
                        <option value="country">Country</option>
                        {/* <option value="time">Time</option> */}
                      </select>
                      <ul>
                        {AlertTypeDesignSetting.map((settingType, index) => {
                          if (index == 3) {
                            return (
                              <div key={`settingMessage${index}`} className={alertMessageColor && alertMessageColor !== "#222" ? "fp-custom-color-btn active fpShowColorPicker" : "fp-custom-color-btn fpShowColorPicker"}>
                                <span className="alertMessage" onClick={() => setShowMessageColorOption(!showMessageColorOption)}>
                                  {svg.app.textcolorIcon}
                                </span>
                                <div className={showMessageColorOption ? "fp_color_drpdwn  show_colorPicker " : "fp_color_drpdwn "}>
                                  <ul>
                                    {HighlightColors.map((highlightedColor, colorIndex) => {
                                      return (
                                        <li key={`color_${colorIndex}`}>
                                          <span
                                            className={`fp-colors ${highlightedColor.label}`}
                                            style={{
                                              boxShadow:
                                                highlightedColor.value === highlightColor
                                                  ? "rgb(204, 204, 204) 2px 2px 3px 2px"
                                                  : "",
                                            }}
                                            onClick={() => {
                                              setAlertMessageColor(highlightedColor.value)
                                              // setHighlightColor(highlightedColor.value)
                                              // setSelectedAlertDesign({ ...selectedAlertDesign, color: highlightedColor.value })
                                            }

                                            }
                                          ></span>
                                        </li>
                                        
                                      );
                                    })}
                                    
                                  </ul>
                                  <ChromePicker
                                      color={alertMessageColor}
                                      disableAlpha = {true}
                                      onChangeComplete={(color) =>{ setAlertMessageColor(color.hex)}}
                                    />
                                  {/* <div className="fp-custom-color-btn fpShowColorPicker fp_title_color">
                                    <input
                                      type="color"
                                      onChange={(e) => {setAlertMessageColor(e.target.value)}}
                                      value={alertMessageColor}
                                    />
                                     <ChromePicker
                                      color={alertMessageColor}
                                      disableAlpha = {true}
                                      onChangeComplete={(color) =>{ setAlertMessageColor(color.hex)}}
                                    />
                                    <span>
                                      {svg.app.editIcon}
                                      Custom Colour
                                    </span>
                                  </div> */}
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <li key={`alertMessage_${index}`}>
                                <a
                                  className={`${settingType?.className
                                    } fp-has-tooltip ${showIsActive(
                                      "alertMessage",
                                      settingType
                                    )}`}
                                  onClick={() =>
                                    handleSettingSelection(
                                      "alertMessage",
                                      settingType.value
                                    )
                                  }
                                >
                                  {settingType?.icon}
                                  <div className={`fp-tooltip-info`}>
                                    {settingType?.name}
                                  </div>
                                </a>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Upload Image  */}

              <div className="fp-upload-image mb-40">
                <label className="fp_label fp_label_list">Image</label>
                <div className="fp_uploadImage" onClick={() => handleImageData()}>
                  <div className="fp_upload cl_uploadnot">
                    <div className="fp_uploadDetail">
                      <svg version="1.1" x="0" y="0" viewBox="0 0 48 48"><g><path d="M16.82 18.74a3.71 3.71 0 1 0-3.7-3.74 3.73 3.73 0 0 0 3.7 3.74zm0-5.42a1.71 1.71 0 1 1-1.7 1.7 1.71 1.71 0 0 1 1.7-1.7zM33.8 29.42A1 1 0 0 0 33 29a1 1 0 0 0-.73.32L29 32.53A1 1 0 0 0 29 34a1 1 0 0 0 1.42 0L32 32.42V36a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3.55l1.49 1.49a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42z" opacity="1" /><path d="M27.33 27.33A8 8 0 0 0 25.07 32H10.61A1.63 1.63 0 0 1 9 30.37v-.24l6.35-6.28a2.74 2.74 0 0 1 3.59-.2l1.61 1.58.12.1a1.91 1.91 0 0 0 2.23 0l5.19-5.1A4.86 4.86 0 0 1 33 19a4.79 4.79 0 0 1 1.48.8l.54.53V21a1 1 0 1 0 2 0v-9.39A3.62 3.62 0 0 0 33.37 8H10.61A3.63 3.63 0 0 0 7 11.61v18.76A3.63 3.63 0 0 0 10.61 34h14.46a8 8 0 1 0 2.26-6.66zM10.61 10h22.76A1.62 1.62 0 0 1 35 11.61v6.18a6.24 6.24 0 0 0-1.41-.66 6.85 6.85 0 0 0-6.9 1.63l-4.93 4.85-.47-.46-.74-.72a4.77 4.77 0 0 0-6.62 0L9 27.32V11.61A1.62 1.62 0 0 1 10.61 10zm26.62 27.23a6 6 0 1 1 0-8.49 6 6 0 0 1 0 8.49z" opacity="1" /></g></svg>
                      <h6 className="">Choose Image</h6>
                    </div>
                  </div>
                </div>
              </div>

              {/* Color Option  */}

              <div className="fp-color-options">
                <h4 className="fp-subtitle">Highlight Colour</h4>
                <div className="fp-color-plate">
                  <ul>
                    {HighlightColors.map((highlightedColor, colorIndex) => {
                      return (
                        <li key={`color_${colorIndex}`}>
                          <span
                            className={`fp-colors ${highlightedColor.label}`}
                            style={{
                              boxShadow:
                                highlightedColor.value === highlightColor
                                  ? "rgb(204, 204, 204) 2px 2px 3px 2px"
                                  : "",
                            }}
                            onClick={() => {
                              setHighlightColor(highlightedColor.value)
                              setSelectedAlertDesign({ ...selectedAlertDesign, color: highlightedColor.value })
                            }

                            }
                          ></span>
                        </li>
                      );
                    })}
                  </ul>
                
                  <div className={`fp-custom-color-btn fp_design_bg_color ${highlightColorPicker && "fpShowColorPicker"}`}>
                    <ChromePicker
                      color={highlightColor}
                      disableAlpha={true}
                      onChangeComplete={(color) => {
                        setHighlightColor(color.hex)
                        setIsColorPickerOpen(false)
                        setSelectedAlertDesign({ ...selectedAlertDesign, color: color.hex })
                      }}
                    />

                    <span className="highlightColor" onClick={() => setHighlightColorPicker(!highlightColorPicker)}>
                      {svg.app.editIcon}
                      Custom Colour
                    </span>
                  </div>
                </div>
              </div>


              {/* bg Color Option  */}

              <div className="fp-color-options mt-3">
                <h4 className="fp-subtitle">BG Color</h4>
                <div className="fp-color-plate">
                  <ul>
                    {Gradientcolors.map((gradientcolor, index) => {
                      return (
                        <li key={`gradientColor_${index}`}>
                          <span
                            className={`fp-colors ${gradientcolor.value}`}
                            onClick={() => {
                              setColor(gradientcolor.colorValue)
                              setSelectedAlertDesign({ ...selectedAlertDesign, gradientColor: gradientcolor.colorValue })
                            }}

                          ></span>
                        </li>
                      );
                    })}
                  </ul>
                  <div
                    className="fp-custom-color-btn fp_gredntColor"
                    style={{ cursor: "pointer" }}
                  >
                    {isColorPickerOpen && (
                      <ColorPicker
                       className={"color12"}
                        value={color}
                        onChange={handleGrediantColor}
                        hideEyeDrop={true}
                        hideAdvancedSliders={true}
                        hideColorGuide={true}
                        hideGradientAngle={true}
                        hideGradientStop={true}
                        hideGradientControls={true}
                        hideGradientType={true}
                        hideOpacity={true}
                        height={200}
                      />
                    )}
                    <span className="customColor"
                      onClick={() => setIsColorPickerOpen(!isColorPickerOpen)}
                    >
                      {svg.app.editIcon}
                      Custom Colour
                    </span>
                  </div>
                </div>
              </div>


            </div>

            {/* Preview Div  */}

            <div className={`fp-alert-design-preview ${selectedAlertDesign?.class}`}>
              <div className="fp-alert-widget-box">
                <div className={`fp-widget-box`}>
                  <span
                    className="fp-widget-style1"
                    style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}
                  ></span>
                  <span className="fp-widget-styletwo"
                    style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}></span>

                  <div className="fp_widget_box_inner" style={{ background: selectedAlertDesign?.type !== "Visitor Alert" && color && color !== "#222" && color }}>
                    <span className="fp-widget-icon"
                      style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}>
                      {isImageUploading ? <div className="spinner-border text-success" role="status">
                      </div> : <img src={showImage(selectedAlertDesign)} alt="templateImage" />
                      }
                    </span>
                    <div className="fp-widget-content" style={{ background: selectedAlertDesign?.type === "Visitor Alert" && color && color !== "#222" && color }}>
                      <h5
                        className={""}
                        style={{
                          color: alertTitleColor && alertTitleColor !== "#222" && alertTitleColor,
                          fontWeight: selectedAlertDesign?.alertTitle?.isBold
                            ? "bold"
                            : "",
                          textDecoration: selectedAlertDesign?.alertTitle
                            ?.isUnderLine
                            ? "underline"
                            : "",
                          fontStyle: selectedAlertDesign?.alertTitle?.isItalic
                            ? "italic"
                            : "",
                        }}
                      >
                        {showTempalteShortCode(selectedAlertDesign, true)}
                      </h5>
                      <p
                        className={""}
                        style={{
                          color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                          fontWeight: selectedAlertDesign?.alertMessage?.isBold
                            ? "bold"
                            : "",
                          textDecoration: selectedAlertDesign?.alertMessage
                            ?.isUnderLine
                            ? "underline"
                            : "",
                          fontStyle: selectedAlertDesign?.alertMessage?.isItalic
                            ? "italic"
                            : "",
                        }}
                      >
                        {showTempalteShortCode(selectedAlertDesign, false)}
                      </p>
                      <div className="fp-widget-info">
                        <span style={{
                          color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                        }}>{selectedAlertDesign?.alertMessage?.time}</span>
                        <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1" /></g></svg>
                        <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />
                        <span style={{
                          color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                        }}>
                          {showSponseredShortCode(selectedAlertDesign)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="fp-btn-wrap fp-creat-camp mt-3">
            <a className="fp-btn" onClick={() => saveDesign()}>
              Next
            </a>
            {props?.alertType?.alertSettings?.prof_campaigns_setting_id && <a className="fp-btn" onClick={() => updateDesign()}>
              Save
            </a>}

          </div>
        </div>
      </div>
    );
  };

  const showBehaviour = () => {
    return (
      <div className="fp-create-camp-body ">
        <div className="fp-alert-settings fp-template-settings">
          <h4 className="fp-subtitle">Behavior</h4>
          <div className="fp-alert-design-settings">
            <div className="fp-alert-design-controls">
              <div className="fp-input-wrap">
                <label>Widget Animations</label>
                <select
                  name=""
                  id=""
                  value={selectedAlertDesign?.widgetAnimation || ""}
                  onChange={(e) =>
                    setSelectedAlertDesign({
                      ...selectedAlertDesign,
                      widgetAnimation: e.target.value,
                    })
                  }
                >
                  {widgetAnimations.map((widget, index) => {
                    return <option key={`widget_${index}`} value={widget.value || ""}>{widget.label}</option>;
                  })}
                </select>
              </div>

              <div className="fp-switch-wrapper mt-30">
                <div className="fp-switch-label">
                  <input
                    type="checkbox"
                    id="translationSwitch12"
                    checked={selectedAlertDesign?.showTime || false}
                    onChange={(e) =>
                      setSelectedAlertDesign({
                        ...selectedAlertDesign,
                        showTime: e.target.checked,
                      })
                    }
                  />
                  <label htmlFor="translationSwitch12"></label>
                </div>
                <p>Hide Time</p>
              </div>

              <div className="fp-switch-wrapper mt-30">
                <div className="fp-switch-label">
                  <input
                    type="checkbox"
                    id="translationSwitch1"
                    checked={selectedAlertDesign?.isFollowSocailMedia || false}
                    onChange={(e) =>
                      setSelectedAlertDesign({
                        ...selectedAlertDesign,
                        isFollowSocailMedia: e.target.checked,
                      })
                    }
                  />
                  <label htmlFor="translationSwitch1"></label>
                </div>
                <p>Follow On Social Media</p>
              </div>

              {selectedAlertDesign?.isFollowSocailMedia && (
                <div className="fp-alert-socials">
                  <div className="fp-input-group fp-facebook">
                    <span>
                      <svg width="10" height="18" viewBox="0 0 10 18">
                        <path
                          d="M5.94907 17.6489V9.59902H8.65001L9.05523 6.46089H5.94907V4.45765C5.94907 3.54938 6.20026 2.9304 7.5042 2.9304L9.16456 2.92971V0.122863C8.87742 0.0855491 7.89179 0 6.74461 0C4.34912 0 2.70913 1.46218 2.70913 4.14685V6.46089H0V9.59902H2.70913V17.6489H5.94907Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder="facebook.com"
                      value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Facebook"] || ""}
                      onChange={(e) =>
                        handleSocialUrlInput(e.target.value, "Facebook")
                      }
                    />
                  </div>
                  <div className="fp-input-group fp-instagram">
                    <span>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M17.1668 5.05203C17.1265 4.13897 16.9786 3.51131 16.7667 2.96737C16.5481 2.39003 16.2118 1.87314 15.7713 1.44344C15.3408 1.00705 14.8196 0.667942 14.2479 0.453172C13.6999 0.241692 13.0744 0.0939912 12.1597 0.0537764C11.2383 0.0100705 10.9457 0 8.60862 0C6.27151 0 5.97899 0.0100705 5.06093 0.0503525C4.1463 0.0906344 3.5175 0.238402 2.97277 0.449748C2.39424 0.667942 1.87644 1.00363 1.44598 1.44344C1.00882 1.87311 0.669287 2.39342 0.45397 2.96408C0.242117 3.51131 0.0941904 4.13561 0.0538711 5.0486C0.0101219 5.96848 0 6.26049 0 8.59348C0 10.9265 0.0101219 11.2185 0.0504411 12.1349C0.090794 13.048 0.238822 13.6757 0.450708 14.2196C0.669287 14.7969 1.00882 15.3138 1.44598 15.7435C1.87644 16.1799 2.39767 16.519 2.96934 16.7338C3.51746 16.9453 4.14287 17.093 5.05767 17.1332C5.97556 17.1736 6.26825 17.1835 8.60536 17.1835C10.9425 17.1835 11.235 17.1736 12.1531 17.1332C13.0677 17.0929 13.6965 16.9453 14.2412 16.7338C14.8133 16.513 15.3329 16.1753 15.7667 15.7423C16.2004 15.3094 16.5388 14.7907 16.76 14.2196C16.9717 13.6724 17.1198 13.048 17.1601 12.1349C17.2005 11.2185 17.2105 10.9265 17.2105 8.59348C17.2105 6.26049 17.2071 5.96844 17.1668 5.05203ZM15.6167 12.0678C15.5796 12.907 15.4384 13.3602 15.3207 13.6623C15.0315 14.4109 14.4363 15.005 13.6864 15.2938C13.3837 15.4113 12.9265 15.5522 12.0891 15.5891C11.1811 15.6295 10.9088 15.6394 8.61205 15.6394C6.31526 15.6394 6.03955 15.6295 5.13487 15.5891C4.29419 15.5522 3.84022 15.4113 3.53757 15.2938C3.16441 15.1561 2.82474 14.9379 2.54899 14.6526C2.26316 14.3739 2.04458 14.0383 1.90664 13.6657C1.78895 13.3636 1.64774 12.907 1.61085 12.0712C1.57037 11.1649 1.56041 10.8929 1.56041 8.60017C1.56041 6.30742 1.57037 6.03219 1.61085 5.12927C1.64774 4.29006 1.78895 3.83689 1.90664 3.53478C2.04458 3.1621 2.26316 2.82309 2.55242 2.54777C2.8314 2.26244 3.16767 2.04424 3.541 1.90671C3.84365 1.78922 4.30105 1.64824 5.1383 1.61128C6.04624 1.571 6.31869 1.56093 8.61531 1.56093C10.9155 1.56093 11.1878 1.571 12.0925 1.61128C12.9332 1.64827 13.3871 1.78919 13.6898 1.90668C14.063 2.04424 14.4027 2.26244 14.6784 2.54777C14.9642 2.82642 15.1828 3.1621 15.3207 3.53478C15.4384 3.83689 15.5796 4.29332 15.6166 5.12927C15.657 6.03561 15.6671 6.30742 15.6671 8.60017C15.6671 10.8929 15.657 11.1615 15.6167 12.0678Z"
                          fill="white"
                        />
                        <path
                          d="M8.60755 4.17928C6.16627 4.17928 4.18555 6.15638 4.18555 8.59351C4.18555 11.0306 6.16627 13.0077 8.60755 13.0077C11.0489 13.0077 13.0296 11.0306 13.0296 8.59351C13.0296 6.15638 11.0489 4.17928 8.60755 4.17928ZM8.60755 11.4569C7.02377 11.4569 5.73907 10.1746 5.73907 8.59351C5.73907 7.01238 7.02377 5.73013 8.60752 5.73013C10.1914 5.73013 11.476 7.01238 11.476 8.59351C11.476 10.1746 10.1914 11.4569 8.60755 11.4569ZM14.2369 4.00472C14.2369 4.57384 13.7746 5.03527 13.2044 5.03527C12.6343 5.03527 12.172 4.57384 12.172 4.00472C12.172 3.43554 12.6343 2.97424 13.2044 2.97424C13.7746 2.97424 14.2369 3.43551 14.2369 4.00472Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder="instagram.com"
                      value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Instagram"] || ""}
                      onChange={(e) =>
                        handleSocialUrlInput(e.target.value, "Instagram")
                      }
                    />
                  </div>
                  <div className="fp-input-group fp-twitter">
                    <span>
                      <svg
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                      >
                        <path
                          d="M10.0066 7.27606L16.2661 0H14.7828L9.34773 6.3177L5.00678 0H0L6.56438 9.55348L0 17.1835H1.48336L7.22291 10.5118L11.8073 17.1835H16.8141L10.0063 7.27606H10.0066ZM7.97498 9.63765L7.30987 8.68634L2.01784 1.11665H4.2962L8.56693 7.22563L9.23204 8.17694L14.7835 16.1177H12.5051L7.97498 9.63801V9.63765Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder="twitter.com"
                      value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Twitter"] || ""}
                      onChange={(e) =>
                        handleSocialUrlInput(e.target.value, "Twitter")
                      }
                    />
                  </div>
                  <div className="fp-input-group fp-pinterest">
                    <span>
                      <svg
                        width="14"
                        height="18"
                        viewBox="0 0 14 18"
                        fill="none"
                      >
                        <path
                          d="M7.21419 0C2.50462 0 0 3.018 0 6.30879C0 7.83498 0.852772 9.73814 2.21785 10.3417C2.42514 10.4352 2.53791 10.3954 2.58409 10.2032C2.62491 10.0571 2.80427 9.35364 2.89126 9.02177C2.91811 8.91544 2.90415 8.82308 2.81823 8.72319C2.36499 8.19907 2.0052 7.24427 2.0052 6.34853C2.0052 4.05335 3.82996 1.82476 6.93495 1.82476C9.62 1.82476 11.4985 3.56897 11.4985 6.06392C11.4985 8.88322 10.0066 10.8336 8.06804 10.8336C6.99509 10.8336 6.19602 9.99161 6.44949 8.94981C6.75559 7.70932 7.35597 6.37538 7.35597 5.48073C7.35597 4.67843 6.90273 4.01469 5.97692 4.01469C4.88464 4.01469 3.99858 5.09623 3.99858 6.5483C3.99858 7.47089 4.32508 8.09382 4.32508 8.09382C4.32508 8.09382 3.24462 12.4586 3.04377 13.2738C2.70438 14.6539 3.08996 16.889 3.12325 17.0812C3.14366 17.1875 3.26287 17.2208 3.32946 17.1338C3.43579 16.9942 4.7418 15.1308 5.10804 13.784C5.24122 13.2931 5.7879 11.303 5.7879 11.303C6.14769 11.9528 7.18627 12.4973 8.29251 12.4973C11.5833 12.4973 13.9612 9.60496 13.9612 6.01559C13.9494 2.57443 11.0044 0 7.21419 0Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                    <input
                      type="text"
                      placeholder="pinterest.com"
                      value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Pinterest"] || ""}
                      onChange={(e) =>
                        handleSocialUrlInput(e.target.value, "Pinterest")
                      }
                    />
                  </div>
                </div>
              )}
            </div>


            <div className={`fp-alert-design-preview  ${selectedAlertDesign?.class}`}>
              <div className="fp-alert-widget-box">
                <div
                  className={`fp-widget-box animate__animated ${selectedAlertDesign?.widgetAnimation}`}

                >
                  <span
                    className="fp-widget-style1"
                    style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}
                  ></span>
                  <span className="fp-widget-styletwo"
                    style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}></span>

                  <div className="fp_widget_box_inner" style={{ background: selectedAlertDesign?.type !== "Visitor Alert" && color && color !== "#222" && color }}>
                    <span className="fp-widget-icon"
                      style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}>
                      <img src={showImage(selectedAlertDesign)} alt="templateImage" />
                    </span>
                    <div className="fp-widget-content" style={{ background: selectedAlertDesign?.type === "Visitor Alert" && color && color !== "#222" && color }}>
                      <h5
                        style={{
                          color: alertTitleColor && alertTitleColor !== "#222" && alertTitleColor,
                          fontWeight: selectedAlertDesign?.alertTitle?.isBold
                            ? "bold"
                            : "",
                          textDecoration: selectedAlertDesign?.alertTitle
                            ?.isUnderLine
                            ? "underline"
                            : "",
                          fontStyle: selectedAlertDesign?.alertTitle?.isItalic
                            ? "italic"
                            : "",
                        }}
                      >
                        {showTempalteShortCode(selectedAlertDesign, true)}
                      </h5>
                      <p
                        style={{
                          color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                          fontWeight: selectedAlertDesign?.alertMessage?.isBold
                            ? "bold"
                            : "",
                          textDecoration: selectedAlertDesign?.alertMessage
                            ?.isUnderLine
                            ? "underline"
                            : "",
                          fontStyle: selectedAlertDesign?.alertMessage?.isItalic
                            ? "italic"
                            : "",
                        }}
                      >
                        {showTempalteShortCode(selectedAlertDesign, false)}
                      </p>
                      <div className="fp-widget-info">
                        <span
                          style={{
                            // color: highlightColor,
                          }}
                        >
                          {/* {selectedAlertDesign?.time} */}
                          {!selectedAlertDesign?.showTime && <span style={{
                            color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                          }}>{selectedAlertDesign?.alertMessage?.time}</span>}
                          <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1" /></g></svg>
                          <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />
                        </span>

                        {!selectedAlertDesign?.isBranding && <>
                          {/* <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" /> */}
                          <span
                            style={{
                              color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
                            }}
                          >

                            {showSponseredShortCode(selectedAlertDesign)}
                          </span> </>}
                      </div>
                      {selectedAlertDesign?.isFollowSocailMedia && (
                        <div className="fp-widget-social">
                          {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Facebook"]
                            ?.length > 0 && (
                              <a href="#" className="fpFacebook">
                                <svg width="15px" height="15px" version="1.1" x="0" y="0" viewBox="0 0 100 100"><g><path d="M40.4 55.2h-9.9c-1.6 0-2.1-.6-2.1-2.1V41c0-1.6.6-2.1 2.1-2.1h9.9v-8.8c0-4 .7-7.8 2.7-11.3 2.1-3.6 5.1-6 8.9-7.4 2.5-.9 5-1.3 7.7-1.3h9.8c1.4 0 2 .6 2 2v11.4c0 1.4-.6 2-2 2-2.7 0-5.4 0-8.1.1-2.7 0-4.1 1.3-4.1 4.1-.1 3 0 5.9 0 9h11.6c1.6 0 2.2.6 2.2 2.2V53c0 1.6-.5 2.1-2.2 2.1H57.3v32.6c0 1.7-.5 2.3-2.3 2.3H42.5c-1.5 0-2.1-.6-2.1-2.1V55.2z" fill="#fff" opacity="1" data-original="#fff" /></g></svg>
                              </a>
                            )}
                          {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Instagram"]
                            ?.length > 0 && (
                              <a href="#" className="fpInsta">
                                <svg width="12" height="12" version="1.1" x="0" y="0" viewBox="0 0 511 511.9"><g><path d="M510.95 150.5c-1.2-27.2-5.598-45.898-11.9-62.102-6.5-17.199-16.5-32.597-29.6-45.398-12.802-13-28.302-23.102-45.302-29.5-16.296-6.3-34.898-10.7-62.097-11.898C334.648.3 325.949 0 256.449 0s-78.199.3-105.5 1.5c-27.199 1.2-45.898 5.602-62.097 11.898-17.204 6.5-32.602 16.5-45.403 29.602-13 12.8-23.097 28.3-29.5 45.3-6.3 16.302-10.699 34.9-11.898 62.098C.75 177.801.449 186.5.449 256s.301 78.2 1.5 105.5c1.2 27.2 5.602 45.898 11.903 62.102 6.5 17.199 16.597 32.597 29.597 45.398 12.801 13 28.301 23.102 45.301 29.5 16.3 6.3 34.898 10.7 62.102 11.898 27.296 1.204 36 1.5 105.5 1.5s78.199-.296 105.5-1.5c27.199-1.199 45.898-5.597 62.097-11.898a130.934 130.934 0 0 0 74.903-74.898c6.296-16.301 10.699-34.903 11.898-62.102 1.2-27.3 1.5-36 1.5-105.5s-.102-78.2-1.3-105.5zm-46.098 209c-1.102 25-5.301 38.5-8.801 47.5-8.602 22.3-26.301 40-48.602 48.602-9 3.5-22.597 7.699-47.5 8.796-27 1.204-35.097 1.5-103.398 1.5s-76.5-.296-103.403-1.5c-25-1.097-38.5-5.296-47.5-8.796C94.551 451.5 84.45 445 76.25 436.5c-8.5-8.3-15-18.3-19.102-29.398-3.5-9-7.699-22.602-8.796-47.5-1.204-27-1.5-35.102-1.5-103.403s.296-76.5 1.5-103.398c1.097-25 5.296-38.5 8.796-47.5C61.25 94.199 67.75 84.1 76.352 75.898c8.296-8.5 18.296-15 29.398-19.097 9-3.5 22.602-7.7 47.5-8.801 27-1.2 35.102-1.5 103.398-1.5 68.403 0 76.5.3 103.403 1.5 25 1.102 38.5 5.3 47.5 8.8 11.097 4.098 21.199 10.598 29.398 19.098 8.5 8.301 15 18.301 19.102 29.403 3.5 9 7.699 22.597 8.8 47.5 1.2 27 1.5 35.097 1.5 103.398s-.3 76.301-1.5 103.301zm0 0" fill="#fff" opacity="1" data-original="#fff" /><path d="M256.45 124.5c-72.598 0-131.5 58.898-131.5 131.5s58.902 131.5 131.5 131.5c72.6 0 131.5-58.898 131.5-131.5s-58.9-131.5-131.5-131.5zm0 216.8c-47.098 0-85.302-38.198-85.302-85.3s38.204-85.3 85.301-85.3c47.102 0 85.301 38.198 85.301 85.3s-38.2 85.3-85.3 85.3zM423.852 119.3c0 16.954-13.747 30.7-30.704 30.7-16.953 0-30.699-13.746-30.699-30.7 0-16.956 13.746-30.698 30.7-30.698 16.956 0 30.703 13.742 30.703 30.699zm0 0" fill="#fff" opacity="1" data-original="#fff" /></g></svg>
                              </a>
                            )}
                          {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Twitter"]
                            ?.length > 0 && (

                              <a href="#" className="fpTwitter">
                                <svg version="1.1" width="11px" height="11px" x="0" y="0" viewBox="0 0 1226.37 1226.37"><g><path d="M727.348 519.284 1174.075 0h-105.86L680.322 450.887 370.513 0H13.185l468.492 681.821L13.185 1226.37h105.866l409.625-476.152 327.181 476.152h357.328L727.322 519.284zM582.35 687.828l-47.468-67.894-377.686-540.24H319.8l304.797 435.991 47.468 67.894 396.2 566.721H905.661L582.35 687.854z" opacity="1" /></g></svg>
                              </a>
                            )}
                          {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Pinterest"]
                            ?.length > 0 && (
                              <a href="#" className="fpPint">
                                <svg width="12px" height="12px" version="1.1" x="0" y="0" viewBox="0 0 511.977 511.977"><g><path d="M262.948 0C122.628 0 48.004 89.92 48.004 187.968c0 45.472 25.408 102.176 66.08 120.16 6.176 2.784 9.536 1.6 10.912-4.128 1.216-4.352 6.56-25.312 9.152-35.2.8-3.168.384-5.92-2.176-8.896-13.504-15.616-24.224-44.064-24.224-70.752 0-68.384 54.368-134.784 146.88-134.784 80 0 135.968 51.968 135.968 126.304 0 84-44.448 142.112-102.208 142.112-31.968 0-55.776-25.088-48.224-56.128 9.12-36.96 27.008-76.704 27.008-103.36 0-23.904-13.504-43.68-41.088-43.68-32.544 0-58.944 32.224-58.944 75.488 0 27.488 9.728 46.048 9.728 46.048S144.676 371.2 138.692 395.488c-10.112 41.12 1.376 107.712 2.368 113.44.608 3.168 4.16 4.16 6.144 1.568 3.168-4.16 42.08-59.68 52.992-99.808 3.968-14.624 20.256-73.92 20.256-73.92 10.72 19.36 41.664 35.584 74.624 35.584 98.048 0 168.896-86.176 168.896-193.12C463.62 76.704 375.876 0 262.948 0z" fill="#fff" opacity="1" data-original="#fff" /></g></svg>
                              </a>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div className="fp-btn-wrap fp-creat-camp fp-behvr-tab">
            <a className="fp-btn" onClick={() => updateDesign()}>
              Save
            </a>
          </div>
        </div>
      </div>
    );
  };

  // const showDesign = () => {
  //   return (
  //     <div className="fp-create-camp-body">
  //       <div className="fp-alert-settings fp-template-settings fp-temp-design">
  //         <h4 className="fp-subtitle">Design</h4>
  //         <div className="fp-alert-design-settings">
  //           <div className="fp-alert-design-controls">
  //             {/* Alert Title  */}
  //             <div className="fp-multioption-field mb-40">
  //               <h4 className="fp-subtitle">Alert Title</h4>
  //               <div className="fp-multifield">
  //                 <div className="fp-input-group">
  //                   <input
  //                     type="text"
  //                     placeholder={showPlaceholder()}
  //                     name="alertTitle"
  //                     value={selectedAlertDesign?.alertTitle?.shortNote || ""}
  //                     onClick={(e) => handleInputClickEvent(e.target)}
  //                     onChange={(e) => handleInputChange(e.target)}
  //                     ref={inputTitleRef}
  //                   />
  //                   <div className="fp-alrt-settings">
  //                     <select
  //                       name="alertTitle"
  //                       id=""
  //                       value={selectedAlertDesign?.alertTitle?.personalization}
  //                       onChange={(e) => handleTitlePersonalization(e.target)}
  //                     >
  //                       <option value="">Add Personalization</option>
  //                       <option value="customer_name">Customer Name</option>
  //                       {selectedAlertDesign?.type === "Sales Alert" && <option value="product_name">Product Name</option>}
  //                       {/* <option value="location">Location</option> */}
  //                       <option value="city">City</option>
  //                       {selectedAlertDesign?.type !== "Visitor Alert" && <option value="state">State</option>}
  //                       <option value="country">Country</option>

  //                     </select>
  //                     <ul>
  //                       {AlertTypeDesignSetting.map((settingType, index) => {
  //                         if (index == 3) {
  //                           return (
  //                             <div key={`settingType${index}`} className={alertTitleColor ? "fp-custom-color-btn active" : "fp-custom-color-btn"}>
  //                               <span onClick={() => setShowAlertColorOption(!showAlertColorOption)}>
  //                                 {svg.app.textcolorIcon}
  //                               </span>
  //                               <div className={showAlertColorOption ? "fp_color_drpdwn show_colorPicker" : "fp_color_drpdwn"}>
  //                                 <ul>
  //                                   {HighlightColors.map((highlightedColor, colorIndex) => {
  //                                     return (
  //                                       <li key={`color_${colorIndex}`}>
  //                                         <span
  //                                           className={`fp-colors ${highlightedColor.label}`}
  //                                           style={{
  //                                             boxShadow:
  //                                               highlightedColor.value === highlightColor
  //                                                 ? "rgb(204, 204, 204) 2px 2px 3px 2px"
  //                                                 : "",
  //                                           }}
  //                                           onClick={() => { handleAlertTilte(highlightedColor.value) }}
  //                                         ></span>
  //                                       </li>
  //                                     );
  //                                   })}
  //                                 </ul>
  //                                 <div className="fp-custom-color-btn fp_title_color">
  //                                   <input
  //                                     type="color"
  //                                     onChange={(e) => setAlertTitleColor(e.target.value)}
  //                                   />
  //                                   <span>
  //                                     {svg.app.editIcon}
  //                                     Custom Colour
  //                                   </span>
  //                                 </div>
  //                               </div>
  //                             </div>
  //                           );
  //                         } else {
  //                           return (
  //                             <li key={`alertTitle_${index}`}>
  //                               <a
  //                                 className={`${settingType?.className
  //                                   } fp-has-tooltip ${showIsActive(
  //                                     "alertTitle",
  //                                     settingType
  //                                   )}`}
  //                                 onClick={() =>
  //                                   handleSettingSelection(
  //                                     "alertTitle",
  //                                     settingType.value
  //                                   )
  //                                 }
  //                               >
  //                                 {settingType?.icon}
  //                                 <div className={`fp-tooltip-info`}>
  //                                   {settingType?.name}
  //                                 </div>
  //                               </a>
  //                             </li>
  //                           );
  //                         }
  //                       })}
  //                     </ul>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             {/* Alert Message  */}

  //             <div className="fp-multioption-field mb-40">
  //               <h4 className="fp-subtitle">Alert Message</h4>
  //               <div className="fp-multifield">
  //                 <div className="fp-input-group">
  //                   <input
  //                     type="text"
  //                     placeholder={showMessagePlaceholder()}
  //                     name="alertMessage"
  //                     value={selectedAlertDesign?.alertMessage?.title || ""}
  //                     onClick={(e) => handleInputClickEvent(e.target)}
  //                     onChange={(e) => handleInputChange(e.target)}
  //                     ref={inputMessageRef}
  //                   />
  //                   <div className="fp-alrt-settings">
  //                     <select
  //                       name="alertMessage"
  //                       id=""
  //                       value={
  //                         selectedAlertDesign?.alertMessage?.personalization
  //                       }
  //                       onChange={(e) => handleMessagePersonalization(e.target)}
  //                     >
  //                       <option value="">Add Personalization</option>
  //                       {selectedAlertDesign?.type !== "Visitor Alert" && <option value="customer_name">Customer Name</option>}
  //                       {selectedAlertDesign?.type === "Sales Alert" && <option value="product_name">Product Name</option>}
  //                       {/* <option value="location">Location</option> */}
  //                       <option value="city">City</option>
  //                       {selectedAlertDesign?.type !== "Visitor Alert" && <option value="state">State</option>}
  //                       <option value="country">Country</option>
  //                       <option value="time">Time</option>
  //                     </select>
  //                     <ul>
  //                       {AlertTypeDesignSetting.map((settingType, index) => {
  //                         if (index == 3) {
  //                           return (
  //                             <div key={`settingMessage${index}`} className={alertMessageColor && alertMessageColor !== "#222" ? "fp-custom-color-btn active" : "fp-custom-color-btn"}>
  //                               <span onClick={() => setShowMessageColorOption(!showMessageColorOption)}>
  //                                 {svg.app.textcolorIcon}
  //                               </span>
  //                               <div className={showMessageColorOption ? "fp_color_drpdwn show_colorPicker" : "fp_color_drpdwn"}>
  //                                 <ul>
  //                                   {HighlightColors.map((highlightedColor, colorIndex) => {
  //                                     return (
  //                                       <li key={`color_${colorIndex}`}>
  //                                         <span
  //                                           className={`fp-colors ${highlightedColor.label}`}
  //                                           style={{
  //                                             boxShadow:
  //                                               highlightedColor.value === highlightColor
  //                                                 ? "rgb(204, 204, 204) 2px 2px 3px 2px"
  //                                                 : "",
  //                                           }}
  //                                           onClick={() => {
  //                                             setAlertMessageColor(highlightedColor.value)
  //                                             // setHighlightColor(highlightedColor.value)
  //                                             // setSelectedAlertDesign({ ...selectedAlertDesign, color: highlightedColor.value })
  //                                           }

  //                                           }
  //                                         ></span>
  //                                       </li>
  //                                     );
  //                                   })}
  //                                 </ul>
  //                                 <div className="fp-custom-color-btn fp_title_color">
  //                                   <input
  //                                     type="color"
  //                                     onChange={(e) => setAlertMessageColor(e.target.value)}
  //                                   />
  //                                   <span>
  //                                     {svg.app.editIcon}
  //                                     Custom Colour
  //                                   </span>
  //                                 </div>
  //                               </div>
  //                             </div>
  //                           );
  //                         } else {
  //                           return (
  //                             <li key={`alertMessage_${index}`}>
  //                               <a
  //                                 className={`${settingType?.className
  //                                   } fp-has-tooltip ${showIsActive(
  //                                     "alertMessage",
  //                                     settingType
  //                                   )}`}
  //                                 onClick={() =>
  //                                   handleSettingSelection(
  //                                     "alertMessage",
  //                                     settingType.value
  //                                   )
  //                                 }
  //                               >
  //                                 {settingType?.icon}
  //                                 <div className={`fp-tooltip-info`}>
  //                                   {settingType?.name}
  //                                 </div>
  //                               </a>
  //                             </li>
  //                           );
  //                         }
  //                       })}
  //                     </ul>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             {/* Upload Image  */}

  //             <div className="fp-upload-image mb-40">
  //               <label className="fp_label fp_label_list">Image</label>
  //               <div className="fp_uploadImage" onClick={() => handleImageData()}>
  //                 <div className="fp_upload cl_uploadnot">
  //                   <div className="fp_uploadDetail">
  //                     <svg version="1.1" x="0" y="0" viewBox="0 0 48 48"><g><path d="M16.82 18.74a3.71 3.71 0 1 0-3.7-3.74 3.73 3.73 0 0 0 3.7 3.74zm0-5.42a1.71 1.71 0 1 1-1.7 1.7 1.71 1.71 0 0 1 1.7-1.7zM33.8 29.42A1 1 0 0 0 33 29a1 1 0 0 0-.73.32L29 32.53A1 1 0 0 0 29 34a1 1 0 0 0 1.42 0L32 32.42V36a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3.55l1.49 1.49a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.42z" opacity="1" /><path d="M27.33 27.33A8 8 0 0 0 25.07 32H10.61A1.63 1.63 0 0 1 9 30.37v-.24l6.35-6.28a2.74 2.74 0 0 1 3.59-.2l1.61 1.58.12.1a1.91 1.91 0 0 0 2.23 0l5.19-5.1A4.86 4.86 0 0 1 33 19a4.79 4.79 0 0 1 1.48.8l.54.53V21a1 1 0 1 0 2 0v-9.39A3.62 3.62 0 0 0 33.37 8H10.61A3.63 3.63 0 0 0 7 11.61v18.76A3.63 3.63 0 0 0 10.61 34h14.46a8 8 0 1 0 2.26-6.66zM10.61 10h22.76A1.62 1.62 0 0 1 35 11.61v6.18a6.24 6.24 0 0 0-1.41-.66 6.85 6.85 0 0 0-6.9 1.63l-4.93 4.85-.47-.46-.74-.72a4.77 4.77 0 0 0-6.62 0L9 27.32V11.61A1.62 1.62 0 0 1 10.61 10zm26.62 27.23a6 6 0 1 1 0-8.49 6 6 0 0 1 0 8.49z" opacity="1" /></g></svg>
  //                     <h6 className="">Choose Image</h6>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>

  //             {/* Color Option  */}

  //             <div className="fp-color-options">
  //               <h4 className="fp-subtitle">Highlight Colour</h4>
  //               <div className="fp-color-plate">
  //                 <ul>
  //                   {HighlightColors.map((highlightedColor, colorIndex) => {
  //                     return (
  //                       <li key={`color_${colorIndex}`}>
  //                         <span
  //                           className={`fp-colors ${highlightedColor.label}`}
  //                           style={{
  //                             boxShadow:
  //                               highlightedColor.value === highlightColor
  //                                 ? "rgb(204, 204, 204) 2px 2px 3px 2px"
  //                                 : "",
  //                           }}
  //                           onClick={() => {
  //                             setHighlightColor(highlightedColor.value)
  //                             setSelectedAlertDesign({ ...selectedAlertDesign, color: highlightedColor.value })
  //                           }

  //                           }
  //                         ></span>
  //                       </li>
  //                     );
  //                   })}
  //                 </ul>
  //                 <div className="fp-custom-color-btn fp_design_bg_color">
  //                   <input
  //                     type="color"
  //                     onChange={(e) => {
  //                       setHighlightColor(e.target.value)
  //                       setSelectedAlertDesign({ ...selectedAlertDesign, color: e.target.value })
  //                     }}
  //                   />
  //                   <span>
  //                     {svg.app.editIcon}
  //                     Custom Colour
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>


  //             {/* Color Option  */}

  //             <div className="fp-color-options mt-3">
  //               <h4 className="fp-subtitle">BG Color</h4>
  //               <div className="fp-color-plate">
  //                 <ul>
  //                   {Gradientcolors.map((gradientcolor, index) => {
  //                     return (
  //                       <li key={`gradientColor_${index}`}>
  //                         <span
  //                           className={`fp-colors ${gradientcolor.value}`}
  //                           onClick={() => {
  //                             setColor(gradientcolor.colorValue)
  //                             setSelectedAlertDesign({ ...selectedAlertDesign, gradientColor: gradientcolor.colorValue })
  //                           }}

  //                         ></span>
  //                       </li>
  //                     );
  //                   })}
  //                 </ul>
  //                 <div
  //                   className="fp-custom-color-btn fp_gredntColor"
  //                   style={{ cursor: "pointer" }}
  //                 >
  //                   {isColorPickerOpen && (
  //                     <ColorPicker
  //                       value={color}
  //                       onChange={handleGrediantColor}
  //                       hideEyeDrop={true}
  //                       hideAdvancedSliders={true}
  //                       hideColorGuide={true}
  //                       hideGradientAngle={true}
  //                       hideGradientStop={true}
  //                       hideGradientControls={true}
  //                       hideGradientType={true}
  //                       hideOpacity={true}
  //                       height={200}
  //                     />
  //                   )}
  //                   <span
  //                     onClick={() => setIsColorPickerOpen(!isColorPickerOpen)}
  //                   >
  //                     {svg.app.editIcon}
  //                     Custom Colour
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>


  //           </div>

  //           {/* Preview Div  */}

  //           <div className={`fp-alert-design-preview ${selectedAlertDesign?.class}`}>
  //             <div className="fp-alert-widget-box">
  //               <div className={`fp-widget-box`}>
  //                 <span
  //                   className="fp-widget-style1"
  //                   style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}
  //                 ></span>
  //                 <span className="fp-widget-styletwo"
  //                   style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}></span>

  //                 <div className="fp_widget_box_inner" style={{ background: selectedAlertDesign?.type !== "Visitor Alert" && color && color !== "#222" && color }}>
  //                   <span className="fp-widget-icon"
  //                     style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}>
  //                     {isImageUploading ? <div className="spinner-border text-success" role="status">
  //                     </div> : <img src={showImage(selectedAlertDesign)} alt="templateImage" />
  //                     }
  //                   </span>
  //                   <div className="fp-widget-content" style={{ background: selectedAlertDesign?.type === "Visitor Alert" && color && color !== "#222" && color }}>
  //                     <h5
  //                       className={""}
  //                       style={{
  //                         color: alertTitleColor && alertTitleColor !== "#222" && alertTitleColor,
  //                         fontWeight: selectedAlertDesign?.alertTitle?.isBold
  //                           ? "bold"
  //                           : "",
  //                         textDecoration: selectedAlertDesign?.alertTitle
  //                           ?.isUnderLine
  //                           ? "underline"
  //                           : "",
  //                         fontStyle: selectedAlertDesign?.alertTitle?.isItalic
  //                           ? "italic"
  //                           : "",
  //                       }}
  //                     >
  //                       {showTempalteShortCode(selectedAlertDesign, true)}
  //                     </h5>
  //                     <p
  //                       className={""}
  //                       style={{
  //                         color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
  //                         fontWeight: selectedAlertDesign?.alertMessage?.isBold
  //                           ? "bold"
  //                           : "",
  //                         textDecoration: selectedAlertDesign?.alertMessage
  //                           ?.isUnderLine
  //                           ? "underline"
  //                           : "",
  //                         fontStyle: selectedAlertDesign?.alertMessage?.isItalic
  //                           ? "italic"
  //                           : "",
  //                       }}
  //                     >
  //                       {showTempalteShortCode(selectedAlertDesign, false)}
  //                     </p>
  //                     <div className="fp-widget-info">
  //                       <span>{selectedAlertDesign?.alertMessage?.time}</span>
  //                       <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1" /></g></svg>
  //                       <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />
  //                       <span style={{
  //                         color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
  //                       }}>
  //                         {showSponseredShortCode(selectedAlertDesign)}
  //                       </span>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //         </div>
  //         <div className="fp-btn-wrap fp-creat-camp mt-3">
  //           <a className="fp-btn" onClick={() => saveDesign()}>
  //             Next
  //           </a>
  //           {props?.alertType?.alertSettings?.prof_campaigns_setting_id && <a className="fp-btn" onClick={() => updateDesign()}>
  //             Save
  //           </a>}

  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const showBehaviour = () => {
  //   return (
  //     <div className="fp-create-camp-body ">
  //       <div className="fp-alert-settings fp-template-settings">
  //         <h4 className="fp-subtitle">Behavior</h4>
  //         <div className="fp-alert-design-settings">
  //           <div className="fp-alert-design-controls">
  //             <div className="fp-input-wrap">
  //               <label>Widget Animations</label>
  //               <select
  //                 name=""
  //                 id=""
  //                 value={selectedAlertDesign?.widgetAnimation || ""}
  //                 onChange={(e) =>
  //                   setSelectedAlertDesign({
  //                     ...selectedAlertDesign,
  //                     widgetAnimation: e.target.value,
  //                   })
  //                 }
  //               >
  //                 {widgetAnimations.map((widget, index) => {
  //                   return <option key={`widget_${index}`} value={widget.value || ""}>{widget.label}</option>;
  //                 })}
  //               </select>
  //             </div>

  //             <div className="fp-switch-wrapper mt-30">
  //               <div className="fp-switch-label">
  //                 <input
  //                   type="checkbox"
  //                   id="translationSwitch1"
  //                   checked={selectedAlertDesign?.isFollowSocailMedia || false}
  //                   onChange={(e) =>
  //                     setSelectedAlertDesign({
  //                       ...selectedAlertDesign,
  //                       isFollowSocailMedia: e.target.checked,
  //                     })
  //                   }
  //                 />
  //                 <label htmlFor="translationSwitch1"></label>
  //               </div>
  //               <p>Follow On Social Media</p>
  //             </div>

  //             {selectedAlertDesign?.isFollowSocailMedia && (
  //               <div className="fp-alert-socials">
  //                 <div className="fp-input-group fp-facebook">
  //                   <span>
  //                     <svg width="10" height="18" viewBox="0 0 10 18">
  //                       <path
  //                         d="M5.94907 17.6489V9.59902H8.65001L9.05523 6.46089H5.94907V4.45765C5.94907 3.54938 6.20026 2.9304 7.5042 2.9304L9.16456 2.92971V0.122863C8.87742 0.0855491 7.89179 0 6.74461 0C4.34912 0 2.70913 1.46218 2.70913 4.14685V6.46089H0V9.59902H2.70913V17.6489H5.94907Z"
  //                         fill="white"
  //                       />
  //                     </svg>
  //                   </span>
  //                   <input
  //                     type="text"
  //                     placeholder="facebook.com"
  //                     value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Facebook"] || ""}
  //                     onChange={(e) =>
  //                       handleSocialUrlInput(e.target.value, "Facebook")
  //                     }
  //                   />
  //                 </div>
  //                 <div className="fp-input-group fp-instagram">
  //                   <span>
  //                     <svg
  //                       width="18"
  //                       height="18"
  //                       viewBox="0 0 18 18"
  //                       fill="none"
  //                     >
  //                       <path
  //                         d="M17.1668 5.05203C17.1265 4.13897 16.9786 3.51131 16.7667 2.96737C16.5481 2.39003 16.2118 1.87314 15.7713 1.44344C15.3408 1.00705 14.8196 0.667942 14.2479 0.453172C13.6999 0.241692 13.0744 0.0939912 12.1597 0.0537764C11.2383 0.0100705 10.9457 0 8.60862 0C6.27151 0 5.97899 0.0100705 5.06093 0.0503525C4.1463 0.0906344 3.5175 0.238402 2.97277 0.449748C2.39424 0.667942 1.87644 1.00363 1.44598 1.44344C1.00882 1.87311 0.669287 2.39342 0.45397 2.96408C0.242117 3.51131 0.0941904 4.13561 0.0538711 5.0486C0.0101219 5.96848 0 6.26049 0 8.59348C0 10.9265 0.0101219 11.2185 0.0504411 12.1349C0.090794 13.048 0.238822 13.6757 0.450708 14.2196C0.669287 14.7969 1.00882 15.3138 1.44598 15.7435C1.87644 16.1799 2.39767 16.519 2.96934 16.7338C3.51746 16.9453 4.14287 17.093 5.05767 17.1332C5.97556 17.1736 6.26825 17.1835 8.60536 17.1835C10.9425 17.1835 11.235 17.1736 12.1531 17.1332C13.0677 17.0929 13.6965 16.9453 14.2412 16.7338C14.8133 16.513 15.3329 16.1753 15.7667 15.7423C16.2004 15.3094 16.5388 14.7907 16.76 14.2196C16.9717 13.6724 17.1198 13.048 17.1601 12.1349C17.2005 11.2185 17.2105 10.9265 17.2105 8.59348C17.2105 6.26049 17.2071 5.96844 17.1668 5.05203ZM15.6167 12.0678C15.5796 12.907 15.4384 13.3602 15.3207 13.6623C15.0315 14.4109 14.4363 15.005 13.6864 15.2938C13.3837 15.4113 12.9265 15.5522 12.0891 15.5891C11.1811 15.6295 10.9088 15.6394 8.61205 15.6394C6.31526 15.6394 6.03955 15.6295 5.13487 15.5891C4.29419 15.5522 3.84022 15.4113 3.53757 15.2938C3.16441 15.1561 2.82474 14.9379 2.54899 14.6526C2.26316 14.3739 2.04458 14.0383 1.90664 13.6657C1.78895 13.3636 1.64774 12.907 1.61085 12.0712C1.57037 11.1649 1.56041 10.8929 1.56041 8.60017C1.56041 6.30742 1.57037 6.03219 1.61085 5.12927C1.64774 4.29006 1.78895 3.83689 1.90664 3.53478C2.04458 3.1621 2.26316 2.82309 2.55242 2.54777C2.8314 2.26244 3.16767 2.04424 3.541 1.90671C3.84365 1.78922 4.30105 1.64824 5.1383 1.61128C6.04624 1.571 6.31869 1.56093 8.61531 1.56093C10.9155 1.56093 11.1878 1.571 12.0925 1.61128C12.9332 1.64827 13.3871 1.78919 13.6898 1.90668C14.063 2.04424 14.4027 2.26244 14.6784 2.54777C14.9642 2.82642 15.1828 3.1621 15.3207 3.53478C15.4384 3.83689 15.5796 4.29332 15.6166 5.12927C15.657 6.03561 15.6671 6.30742 15.6671 8.60017C15.6671 10.8929 15.657 11.1615 15.6167 12.0678Z"
  //                         fill="white"
  //                       />
  //                       <path
  //                         d="M8.60755 4.17928C6.16627 4.17928 4.18555 6.15638 4.18555 8.59351C4.18555 11.0306 6.16627 13.0077 8.60755 13.0077C11.0489 13.0077 13.0296 11.0306 13.0296 8.59351C13.0296 6.15638 11.0489 4.17928 8.60755 4.17928ZM8.60755 11.4569C7.02377 11.4569 5.73907 10.1746 5.73907 8.59351C5.73907 7.01238 7.02377 5.73013 8.60752 5.73013C10.1914 5.73013 11.476 7.01238 11.476 8.59351C11.476 10.1746 10.1914 11.4569 8.60755 11.4569ZM14.2369 4.00472C14.2369 4.57384 13.7746 5.03527 13.2044 5.03527C12.6343 5.03527 12.172 4.57384 12.172 4.00472C12.172 3.43554 12.6343 2.97424 13.2044 2.97424C13.7746 2.97424 14.2369 3.43551 14.2369 4.00472Z"
  //                         fill="white"
  //                       />
  //                     </svg>
  //                   </span>
  //                   <input
  //                     type="text"
  //                     placeholder="instagram.com"
  //                     value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Instagram"] || ""}
  //                     onChange={(e) =>
  //                       handleSocialUrlInput(e.target.value, "Instagram")
  //                     }
  //                   />
  //                 </div>
  //                 <div className="fp-input-group fp-twitter">
  //                   <span>
  //                     <svg
  //                       width="17"
  //                       height="18"
  //                       viewBox="0 0 17 18"
  //                       fill="none"
  //                     >
  //                       <path
  //                         d="M10.0066 7.27606L16.2661 0H14.7828L9.34773 6.3177L5.00678 0H0L6.56438 9.55348L0 17.1835H1.48336L7.22291 10.5118L11.8073 17.1835H16.8141L10.0063 7.27606H10.0066ZM7.97498 9.63765L7.30987 8.68634L2.01784 1.11665H4.2962L8.56693 7.22563L9.23204 8.17694L14.7835 16.1177H12.5051L7.97498 9.63801V9.63765Z"
  //                         fill="white"
  //                       />
  //                     </svg>
  //                   </span>
  //                   <input
  //                     type="text"
  //                     placeholder="twitter.com"
  //                     value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Twitter"] || ""}
  //                     onChange={(e) =>
  //                       handleSocialUrlInput(e.target.value, "Twitter")
  //                     }
  //                   />
  //                 </div>
  //                 <div className="fp-input-group fp-pinterest">
  //                   <span>
  //                     <svg
  //                       width="14"
  //                       height="18"
  //                       viewBox="0 0 14 18"
  //                       fill="none"
  //                     >
  //                       <path
  //                         d="M7.21419 0C2.50462 0 0 3.018 0 6.30879C0 7.83498 0.852772 9.73814 2.21785 10.3417C2.42514 10.4352 2.53791 10.3954 2.58409 10.2032C2.62491 10.0571 2.80427 9.35364 2.89126 9.02177C2.91811 8.91544 2.90415 8.82308 2.81823 8.72319C2.36499 8.19907 2.0052 7.24427 2.0052 6.34853C2.0052 4.05335 3.82996 1.82476 6.93495 1.82476C9.62 1.82476 11.4985 3.56897 11.4985 6.06392C11.4985 8.88322 10.0066 10.8336 8.06804 10.8336C6.99509 10.8336 6.19602 9.99161 6.44949 8.94981C6.75559 7.70932 7.35597 6.37538 7.35597 5.48073C7.35597 4.67843 6.90273 4.01469 5.97692 4.01469C4.88464 4.01469 3.99858 5.09623 3.99858 6.5483C3.99858 7.47089 4.32508 8.09382 4.32508 8.09382C4.32508 8.09382 3.24462 12.4586 3.04377 13.2738C2.70438 14.6539 3.08996 16.889 3.12325 17.0812C3.14366 17.1875 3.26287 17.2208 3.32946 17.1338C3.43579 16.9942 4.7418 15.1308 5.10804 13.784C5.24122 13.2931 5.7879 11.303 5.7879 11.303C6.14769 11.9528 7.18627 12.4973 8.29251 12.4973C11.5833 12.4973 13.9612 9.60496 13.9612 6.01559C13.9494 2.57443 11.0044 0 7.21419 0Z"
  //                         fill="white"
  //                       />
  //                     </svg>
  //                   </span>
  //                   <input
  //                     type="text"
  //                     placeholder="pinterest.com"
  //                     value={selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Pinterest"] || ""}
  //                     onChange={(e) =>
  //                       handleSocialUrlInput(e.target.value, "Pinterest")
  //                     }
  //                   />
  //                 </div>
  //               </div>
  //             )}
  //           </div>

  //           <div className={`fp-alert-design-preview  ${selectedAlertDesign?.class}`}>
  //             <div className="fp-alert-widget-box">
  //               <div
  //                 className={`fp-widget-box animate__animated ${selectedAlertDesign?.widgetAnimation}`}

  //               >
  //                 <span
  //                   className="fp-widget-style1"
  //                   style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}
  //                 ></span>
  //                 <span className="fp-widget-styletwo"
  //                   style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}></span>

  //                 <div className="fp_widget_box_inner" style={{ background: selectedAlertDesign?.type !== "Visitor Alert" && color && color !== "#222" && color }}>
  //                   <span className="fp-widget-icon"
  //                     style={{ background: highlightColor && highlightColor !== "#222" && highlightColor }}>
  //                     <img src={showImage(selectedAlertDesign)} alt="templateImage" />
  //                   </span>
  //                   <div className="fp-widget-content" style={{ background: selectedAlertDesign?.type === "Visitor Alert" && color && color !== "#222" && color }}>
  //                     <h5
  //                       style={{
  //                         color: alertTitleColor && alertTitleColor !== "#222" && alertTitleColor,
  //                         fontWeight: selectedAlertDesign?.alertTitle?.isBold
  //                           ? "bold"
  //                           : "",
  //                         textDecoration: selectedAlertDesign?.alertTitle
  //                           ?.isUnderLine
  //                           ? "underline"
  //                           : "",
  //                         fontStyle: selectedAlertDesign?.alertTitle?.isItalic
  //                           ? "italic"
  //                           : "",
  //                       }}
  //                     >
  //                       {showTempalteShortCode(selectedAlertDesign, true)}
  //                     </h5>
  //                     <p
  //                       style={{
  //                         color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
  //                         fontWeight: selectedAlertDesign?.alertMessage?.isBold
  //                           ? "bold"
  //                           : "",
  //                         textDecoration: selectedAlertDesign?.alertMessage
  //                           ?.isUnderLine
  //                           ? "underline"
  //                           : "",
  //                         fontStyle: selectedAlertDesign?.alertMessage?.isItalic
  //                           ? "italic"
  //                           : "",
  //                       }}
  //                     >
  //                       {showTempalteShortCode(selectedAlertDesign, false)}
  //                     </p>
  //                     <div className="fp-widget-info">
  //                       <span
  //                         style={{
  //                           // color: highlightColor,
  //                         }}
  //                       >
  //                         {/* {selectedAlertDesign?.time} */}
  //                         <span>{selectedAlertDesign?.alertMessage?.time}</span>
  //                         <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 66 66"><g><path d="M25.97 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM46.09 4.02c0-1.67-1.36-3.02-3.03-3.02s-3.02 1.35-3.02 3.02v12.69h6.05zM50.87 18.71H15.13c-1.67 0-3.02 1.35-3.02 3.02s1.35 3.02 3.02 3.02h35.73c1.67 0 3.02-1.35 3.02-3.02a3.002 3.002 0 0 0-3.01-3.02zM30.76 64.92c.74.05 1.49.08 2.24.08s1.5-.03 2.24-.08v-9.85h-4.47v9.85zM28.46 50.88h9.09v2.19h-9.09zM17.15 39.94l8.94 8.94h13.82l8.95-8.94V26.76H17.15zM34.1 29.83v7.52h3.8l-6.01 8.46v-7.52h-3.8z" opacity="1" /></g></svg>
  //                         <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" />
  //                       </span>

  //                       {!selectedAlertDesign?.isBranding && <>
  //                         {/* <img src="https://img.flexifunnels.com/flexiproof-assets/fav.svg" alt="" /> */}
  //                         <span
  //                           style={{
  //                             color: alertMessageColor && alertMessageColor !== "#222" && alertMessageColor,
  //                           }}
  //                         >

  //                           {showSponseredShortCode(selectedAlertDesign)}
  //                         </span> </>}
  //                     </div>
  //                     {selectedAlertDesign?.isFollowSocailMedia && (
  //                       <div className="fp-widget-social">
  //                         {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Facebook"]
  //                           ?.length > 0 && (
  //                             <a href="#" className="fpFacebook">
  //                               <svg
  //                                 xmlns="http://www.w3.org/2000/svg"
  //                                 width="10"
  //                                 height="18"
  //                                 fill="none"
  //                               >
  //                                 <path
  //                                   fill="#fff"
  //                                   d="M5.949 17.649v-8.05H8.65l.405-3.138H5.949V4.458c0-.908.251-1.527 1.555-1.527h1.66V.123A22.564 22.564 0 006.745 0C4.349 0 2.709 1.462 2.709 4.147v2.314H0v3.138h2.709v8.05h3.24z"
  //                                 ></path>
  //                               </svg>
  //                             </a>
  //                           )}
  //                         {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Instagram"]
  //                           ?.length > 0 && (
  //                             <a href="#" className="fpInsta">
  //                               <svg
  //                                 xmlns="http://www.w3.org/2000/svg"
  //                                 width="18"
  //                                 height="18"
  //                                 fill="none"
  //                               >
  //                                 <path
  //                                   fill="url(#A)"
  //                                   d="M17.747 5.052c-.04-.913-.188-1.541-.4-2.085a4.19 4.19 0 00-.995-1.524 4.254 4.254 0 00-1.523-.99C14.28.242 13.655.094 12.74.054L9.189 0 5.641.05c-.915.04-1.543.188-2.088.399a4.2 4.2 0 00-1.527.994 4.23 4.23 0 00-.992 1.521c-.212.547-.36 1.172-.4 2.085L.58 8.593l.05 3.541c.04.913.188 1.541.4 2.085a4.25 4.25 0 00.995 1.524c.43.436.952.775 1.523.99.548.212 1.174.359 2.088.399l3.548.05 3.548-.05c.915-.04 1.543-.188 2.088-.399a4.39 4.39 0 002.519-2.514c.212-.547.36-1.172.4-2.085l.05-3.541-.044-3.541zm-1.55 7.016c-.037.839-.178 1.292-.296 1.595a2.847 2.847 0 01-1.634 1.631c-.303.118-.76.258-1.597.295l-3.477.05c-2.297 0-2.573-.01-3.477-.05-.841-.037-1.295-.178-1.597-.295a2.65 2.65 0 01-.989-.641 2.67 2.67 0 01-.642-.987c-.118-.302-.259-.759-.296-1.594L2.14 8.6l.05-3.471c.037-.839.178-1.292.296-1.594a2.61 2.61 0 01.646-.987 2.67 2.67 0 01.989-.641c.303-.117.76-.258 1.597-.295l3.477-.05 3.477.05c.841.037 1.295.178 1.597.295.373.138.713.356.989.641a2.67 2.67 0 01.642.987c.118.302.259.759.296 1.594l.05 3.471-.05 3.468z"
  //                                 ></path>
  //                                 <path
  //                                   fill="url(#B)"
  //                                   d="M9.188 4.179a4.42 4.42 0 00-4.422 4.414 4.42 4.42 0 108.844 0 4.42 4.42 0 00-4.422-4.414zm0 7.278c-1.584 0-2.868-1.282-2.868-2.863S7.604 5.73 9.188 5.73s2.869 1.282 2.869 2.863-1.285 2.863-2.868 2.863zm5.629-7.452a1.03 1.03 0 11-2.065 0 1.03 1.03 0 112.065 0z"
  //                                 ></path>
  //                                 <defs>
  //                                   <linearGradient
  //                                     id="A"
  //                                     x1="9.185"
  //                                     x2="9.185"
  //                                     y1="0"
  //                                     y2="17.184"
  //                                     gradientUnits="userSpaceOnUse"
  //                                   >
  //                                     <stop stopColor="#fff"></stop>
  //                                     <stop offset="1" stopColor="#fff"></stop>
  //                                   </linearGradient>
  //                                   <linearGradient
  //                                     id="B"
  //                                     x1="9.791"
  //                                     x2="9.791"
  //                                     y1="2.974"
  //                                     y2="13.008"
  //                                     gradientUnits="userSpaceOnUse"
  //                                   >
  //                                     <stop stopColor="#fff"></stop>
  //                                     <stop offset="1" stopColor="#fff"></stop>
  //                                   </linearGradient>
  //                                 </defs>
  //                               </svg>
  //                             </a>
  //                           )}
  //                         {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Twitter"]
  //                           ?.length > 0 && (

  //                             <a href="#" className="fpTwitter">
  //                               <svg
  //                                 xmlns="http://www.w3.org/2000/svg"
  //                                 width="17"
  //                                 height="18"
  //                                 fill="none"
  //                               >
  //                                 <path
  //                                   fill="#fff"
  //                                   d="M10.073 7.276L16.333 0H14.85L9.414 6.318 5.073 0H.066L6.63 9.553l-6.564 7.63H1.55l5.74-6.672 4.584 6.672h5.007l-6.808-9.907zM8.041 9.638l-.665-.951-5.292-7.57h2.278l4.271 6.109.665.951 5.551 7.941h-2.278l-4.53-6.48z"
  //                                 ></path>
  //                               </svg>
  //                             </a>
  //                           )}
  //                         {selectedAlertDesign?.socialMediaUrls && selectedAlertDesign?.socialMediaUrls["Pinterest"]
  //                           ?.length > 0 && (
  //                             <a href="#" className="fpPint">
  //                               <svg
  //                                 xmlns="http://www.w3.org/2000/svg"
  //                                 width="15"
  //                                 height="18"
  //                                 fill="none"
  //                               >
  //                                 <path
  //                                   fill="#fff"
  //                                   d="M7.88 0C3.171 0 .666 3.018.666 6.309c0 1.526.853 3.429 2.218 4.033.207.094.32.054.366-.138l.307-1.181a.304.304 0 00-.073-.299c-.453-.524-.813-1.479-.813-2.375 0-2.295 1.825-4.524 4.93-4.524 2.685 0 4.564 1.744 4.564 4.239 0 2.819-1.492 4.77-3.43 4.77-1.073 0-1.872-.842-1.619-1.884.306-1.24.906-2.574.906-3.469 0-.802-.453-1.466-1.379-1.466-1.092 0-1.978 1.082-1.978 2.534 0 .923.327 1.546.327 1.546l-1.281 5.18c-.339 1.38.046 3.615.079 3.807.02.106.14.14.206.053.106-.14 1.412-2.003 1.779-3.35l.68-2.481c.36.65 1.398 1.194 2.505 1.194 3.291 0 5.669-2.892 5.669-6.482C14.615 2.574 11.67 0 7.88 0z"
  //                                 ></path>
  //                               </svg>
  //                             </a>
  //                           )}
  //                       </div>
  //                     )}
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //         </div>
  //         <div className="fp-btn-wrap fp-creat-camp fp-behvr-tab">
  //           <a className="fp-btn" onClick={() => saveDesign()}>
  //             Save
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <>
      {/* Hidden Setting Tabs  */}
      <div className="tab-main-box fp-setting-tabs">
        <div className="tab-create-camp-wrapper">
          <div className="fp-create-camp-heading fp_alrt_type_head">
            <h4>{props?.alertType?.icon}{props?.alertType?.name}</h4>
          </div>
          <div className="fp-alert-setting-tab">
            {/* Setting Tabs  */}
            <Tabs
              defaultActiveKey="productTab"
              activeKey={activeTab}
              onSelect={handleTabSelect}
            >
              <Tab
                eventKey="productTab"
                title={
                  props?.alertType?.name === "Sales Alert"
                    ? <div className="fp_front_icons fp_alerts_icons">
                      <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 32 32"><g><path d="M26 2h-5v9a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V2H6a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zM8 20h5a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2zm7 6H8a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm4-15h-6V2h6z" opacity="1" /></g></svg>
                      <span>Products</span>
                    </div>
                    : <div className="fp_front_icons fp_alerts_icons">
                      <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 28 28"><g><g data-name="Layer 2"><path d="M22.6 1H5.4A4.4 4.4 0 0 0 1 5.4V7h26V5.4A4.4 4.4 0 0 0 22.6 1zM5 5a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm3 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1zM15.656 19.646a2.333 2.333 0 1 0-3.3.01 2.4 2.4 0 0 0 3.3-.01z" opacity="1" /><path d="M1 22.6A4.4 4.4 0 0 0 5.4 27h17.2a4.4 4.4 0 0 0 4.4-4.4V9H1zM9 17h.8a4.3 4.3 0 0 1 .524-1.266l-.56-.56a1 1 0 1 1 1.414-1.414l.561.561A4.294 4.294 0 0 1 13 13.8V13a1 1 0 0 1 2 0v.8a4.3 4.3 0 0 1 1.266.524l.56-.56a1 1 0 1 1 1.414 1.414l-.561.561A4.3 4.3 0 0 1 18.2 17h.8a1 1 0 0 1 0 2h-.8a4.3 4.3 0 0 1-.524 1.266l.56.56a1 1 0 1 1-1.414 1.414l-.561-.561A4.294 4.294 0 0 1 15 22.2v.8a1 1 0 0 1-2 0v-.8a4.3 4.3 0 0 1-1.266-.524l-.56.56a1 1 0 1 1-1.414-1.41l.561-.561A4.3 4.3 0 0 1 9.8 19H9a1 1 0 0 1 0-2z" opacity="1" /></g></g></svg>
                      <span>Pages</span>
                    </div>
                }

              >
                {props?.alertType?.name === "Sales Alert"
                  ? showProducts()
                  : showPages()}

              </Tab>

              <Tab eventKey="dfyTemplatesTab" title={
                <div className="fp_front_icons fp_alerts_icons">
                  <svg width="16px" height="16px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path d="M331 376h60v60h-60zM121 376h120v60H121z" opacity="1" /><path d="M0 466c0 24.814 20.186 46 45 46h422c24.814 0 45-21.186 45-46V150H0zm421-15c0 8.291-6.709 15-15 15h-90c-8.291 0-15-6.709-15-15v-90c0-8.291 6.709-15 15-15h90c8.291 0 15 6.709 15 15zM91 211c0-8.291 6.709-15 15-15h300c8.291 0 15 6.709 15 15v90c0 8.291-6.709 15-15 15H106c-8.291 0-15-6.709-15-15zm0 150c0-8.291 6.709-15 15-15h150c8.291 0 15 6.709 15 15v90c0 8.291-6.709 15-15 15H106c-8.291 0-15-6.709-15-15z" opacity="1" /><path d="M121 226h270v60H121zM467 0H45C20.186 0 0 20.186 0 45v75h512V45c0-24.814-20.186-45-45-45zM106 75c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15z" opacity="1" /></g></svg>
                  <span>DFY Templates</span>
                </div>
              }
                disabled={tabIsDisabled(props?.alertType.value)}>
                {showTemplates()}

              </Tab>

              <Tab eventKey="designTab" title={
                <div className="fp_front_icons fp_alerts_icons">
                  <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 512.007 512.007"><g><path d="M151 421.004c0-33.091-26.909-60-60-60s-60 26.909-60 60v30c0 16.538-14.462 31-31 31v30h61c49.629 0 90-41.371 90-91zM251.063 125.603c-8.005 2.153-12.762 10.351-10.605 18.369 2.067 7.714 9.983 12.788 18.369 10.605 8.06-2.168 12.739-10.406 10.605-18.369-2.166-8.047-10.451-12.74-18.369-10.605zM166.205 239.436c7.96 2.111 16.196-2.521 18.369-10.605 2.166-8.082-2.655-16.236-10.591-18.369h-.015c-4.255-1.148-5.405-.284-8.414.698.17 9.04.289 18.419.352 28.129.11.032.187.118.299.147zM331.542 368.02c-2.17-8.066-10.448-12.728-18.369-10.591-8.143 2.19-12.722 10.499-10.605 18.369 2.139 7.983 10.283 12.7 18.369 10.605 8.005-2.153 12.762-10.351 10.605-18.369zM381.464 181.765c5.845-5.859 5.845-15.381 0-21.226-5.848-5.848-15.353-5.872-21.226 0-5.845 5.845-5.845 15.381.015 21.226 5.83 5.83 15.351 5.83 21.211 0z" /><path d="M286.879 30.213c-49.276 1.776-94.508 21.255-130.562 45.985 4.041 27.508 6.896 61.747 8.416 104.092 5.616-.67 11.36-.315 16.985 1.198 24.038 6.427 38.287 31.069 31.831 55.107-5.442 20.332-23.809 33.369-43.389 33.369-1.441 0-2.877-.432-4.318-.571-.181 23.992-.725 47.73-1.76 70.399 15.364 6.383 27.372 14.886 35.213 25.9 15.879 22.31 11.646 48.472 9.976 55.972-5.563 24.913 9.126 50.275 34.292 55.122a226.979 226.979 0 0 0 42.715 4.072c123.369 0 226.727-100.21 225.722-226.655-1.051-128.243-112.028-228.251-225.121-223.99zm52.134 109.116c17.578-17.549 46.113-17.549 63.662 0s17.549 46.099 0 63.647v.015c-17.547 17.518-46.099 17.52-63.647 0-17.535-17.564-17.535-46.113-.015-63.662zm-127.53 12.392c-6.385-23.714 7.54-48.604 31.816-55.093 23.862-6.401 48.662 7.837 55.107 31.816 6.443 23.989-7.773 48.671-31.816 55.107-23.981 6.427-48.663-7.729-55.107-31.83zM328.7 415.379c-23.976 6.423-48.677-7.857-55.107-31.816-6.443-23.989 7.773-48.671 31.816-55.107 24.144-6.423 48.693 7.841 55.107 31.831 6.462 24.026-7.825 48.677-31.816 55.092zm116.674-116.675c-6.426 24.038-31.126 38.265-55.107 31.816-23.974-6.418-38.286-31.024-31.816-55.107 6.493-24.258 31.34-38.185 55.107-31.816 23.98 6.43 38.248 31.157 31.816 55.107z" /><path d="M405.795 272.571c-7.857-2.119-16.177 2.459-18.369 10.605-2.166 8.082 2.655 16.236 10.591 18.369 8.214 2.122 16.256-2.692 18.384-10.605 2.138-7.983-2.623-16.23-10.606-18.369zM135.819 271.004c.042-5.019.181-9.959.181-15 0-116.323-7.808-256-45-256s-45 139.677-45 256c0 5.041.139 9.981.181 15zM91 331.004c15.63 0 30.121 4.362 42.942 11.398a1767.157 1767.157 0 0 0 1.489-41.398H46.569c.346 14.07.84 27.936 1.489 41.398C60.879 335.365 75.37 331.004 91 331.004z" /></g></svg>
                  <span>Design</span>
                </div>
              }
                disabled={tabIsDisabled(props?.alertType.value)}>
                {showDesign()}
              </Tab>

              <Tab eventKey="behaviorTab" title={
                <div className="fp_front_icons fp_alerts_icons">
                  <svg width="18px" height="18px" version="1.1" x="0" y="0" viewBox="0 0 512 512"><g><path d="M288.133 142.621c-66.715 2.836-64.539 98.633 2.184 98.485-22.691-27.42-22.689-71.017 0-98.437a49.592 49.592 0 0 0-2.184-.048z" /><path d="M223.867 142.621c-66.715 2.836-64.539 98.633 2.184 98.485-22.691-27.42-22.689-71.017 0-98.437a49.66 49.66 0 0 0-2.184-.048zM352.4 142.621c-27.166 0-49.267 22.101-49.267 49.267 2.477 65.269 96.066 65.251 98.533-.001.001-27.165-22.101-49.266-49.266-49.266z" /><path d="M159.6 142.621c-66.715 2.836-64.539 98.633 2.184 98.485-22.691-27.42-22.689-71.017 0-98.437a49.592 49.592 0 0 0-2.184-.048z" /><path d="M464.867.154H47.133C21.059.154 0 21.256 0 47.287v289.2c0 26.075 21.105 47.133 47.133 47.133h417.733c26.075 0 47.133-21.104 47.133-47.133v-289.2C512 21.216 490.899.154 464.867.154zm-112.467 271a78.775 78.775 0 0 1-32.108-6.82c-19.893 9.082-44.66 8.994-64.267 0-19.893 9.082-44.66 8.994-64.267 0-51.067 23.64-112.298-16.102-111.425-72.447-.873-56.335 60.367-96.097 111.426-72.446 19.609-8.994 44.371-9.082 64.267 0 19.609-8.994 44.372-9.082 64.267 0 50.852-23.673 112.32 16.136 111.374 72.448 0 43.706-35.56 79.265-79.267 79.265zM497 450.021H187.057c1.957 9.651 1.957 20.349 0 30H497c19.881-.738 19.866-29.27 0-30zM111.4 417.887c-25.989 0-47.133 21.144-47.133 47.133 2.37 62.443 91.906 62.426 94.267-.001-.001-25.988-21.145-47.132-47.134-47.132zM15 450.021c-19.881.738-19.866 29.269 0 30h20.742c-1.957-9.651-1.957-20.349 0-30z" /></g></svg>
                  <span>Behavior</span>
                </div>
              }
                disabled={tabIsDisabled(props?.alertType.value)}>
                {showBehaviour()}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      < AlertModel alert={alert} onClose={() => setAlert({ ...alert, status: false, type: "", title: "", message: "" })} />

      <Model
        shownPopup={uploadImageModel}
        type={selectedAlertDesign?.type}
        images={imageLibraryList}
        imageLoading={imageLoading}
        pagination={{ currentPage: page, totalPage: totalPages }}
        closePopup={() => {
          setUploadImageModel(false)
        }}
        handleUpload={(data) => {
          handleUploadImage(data)
          setUploadImageModel(false)
        }}

        handleLibraryImage={(data) => {
          if (selectedAlertDesign?.type === "Visitor Alert") {
            if (templateType == "icon") {
              let currentAlert = structuredClone(selectedAlertDesign)
              currentAlert.IconImg = data
              setSelectedAlertDesign({ ...currentAlert })
              setUploadImageModel(false)
            } else {
              let currentAlert = structuredClone(selectedAlertDesign)
              currentAlert.tempImg = data
              setSelectedAlertDesign({ ...currentAlert })
              setUploadImageModel(false)
            }
          } else {
            let currentAlert = structuredClone(selectedAlertDesign)
            currentAlert.tempImg = data
            setSelectedAlertDesign({ ...currentAlert })
            setUploadImageModel(false)
          }
        }}

        handleLoadMore={(updatedPage) => {
          setPage(updatedPage)
        }}
      />
    </>
  );
}
